module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e8r407"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c5_r1#d6e1",
      "id": "d7e1"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#f2ac0c"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#82a339"
    }
  }, [_vm._v("BASICS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "h1l",
    staticStyle: {
      "color": "#c15b49"
    },
    attrs: {
      "id": "d7e8487"
    }
  }, [_c('b', [_vm._v("EQUIPMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e8537"
    }
  }, [_vm._v("A well-equipped kitchen is a must for cooking delicious meals. You can accomplish a lot with a good set of knives and a few well-chosen pots and pans. Just remember, you often get what you pay for. High-quality utensils, made from durable materials, last longer, so buy the best you can afford.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e8767"
    }
  }, [_vm._v("Stainless steel is easy to clean and not too heavy, but it isn’t a very good conductor of heat; an aluminum or copper core is often added to improve its heat-conducting properties. By contrast, copper is an excellent conductor of heat and copper pots are gorgeous, but the pots must be polished and can be very heavy. Cast iron and aluminum are inexpensive and excellent heat conductors. Unfortunately, they react to acidic ingredients, such as tomatoes and wine, but they are also available enamel-coated.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e9147"
    }
  }, [_c('b', [_vm._v("ON THE STOVE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e9207"
    }
  }, [_vm._v("Here is a list of basic pots and pans that every kitchen should be equipped with:")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e9307"
    }
  }, [_c('b', [_c('i', [_vm._v("Saucepan ")])]), _vm._v("Three or four saucepans with lids, ranging from 1 to 4 quarts. They should be between 3½ to 4 inches deep, so you can stir without spilling food over the side.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e9557"
    }
  }, [_c('b', [_c('i', [_vm._v("Dutch oven ")])]), _vm._v("These pots are ideal for braising roasts and stews on top of the stove as well as in the oven. A 5- to 6-quart Dutch oven is the most useful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e9697"
    }
  }, [_c('b', [_c('i', [_vm._v("Skillets ")])]), _vm._v("You’ll need at least three sizes: small (8-inch), medium (9- to 10-inch), and large (12-inch).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e9817"
    }
  }, [_c('b', [_c('i', [_vm._v("Saucepot ")])]), _vm._v("This wide, deep pot can be used for soups and stews. A 5-quart saucepot that has a tight-fitting lid is versatile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e9947"
    }
  }, [_c('b', [_c('i', [_vm._v("Stockpot ")])]), _vm._v("A tall, narrow, 6- to 8-quart stockpot can be called into action to cook many foods, including pasta, soups, stocks, lobster, and corn on the cob.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0007_001",
      "src": "Images/9781618371621_0007_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e10127"
    }
  }, [_c('i', [_vm._v("Basic cooking equipment: steamer, saucepans, grill pan, Dutch oven, thermometers, skillets, double boiler")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e10238"
    }
  }, [_c('b', [_c('i', [_vm._v("Double boiler ")])]), _vm._v("A saucepan topped with another covered saucepan; food is gently cooked in the top pan by water simmering in the bottom pan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e10368"
    }
  }, [_c('b', [_c('i', [_vm._v("Grill pan ")])]), _vm._v("This ridged skillet acts as a stovetop grill. Food can be cooked with little or no added fat; the ridges allow any rendered fat to drip away as the food cooks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e10538"
    }
  }, [_c('b', [_c('i', [_vm._v("Griddle ")])]), _vm._v("This flat metal pan can be heated on top of the stove to cook pancakes, French toast, cheese sandwiches, and bacon. Electric models (some have nonstick surfaces) are also available.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e10728"
    }
  }, [_c('b', [_vm._v("IN THE OVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e10778"
    }
  }, [_vm._v("Some of the most popular materials for bakeware include enameled cast iron (easy to clean and a good heat conductor), enameled steel (a reasonably priced, lightweight choice for roasting pans), stainless steel (moderately heavy and durable), aluminum (often laminated to create a nonstick surface), heat-resistant glass (a popular, inexpensive choice), and glass-ceramic (which can go from oven to freezer). Earthenware and stoneware are good for long, slow baking, like stews or beans.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e11098"
    }
  }, [_vm._v("Cake pans that have a dull heat-absorbing finish, such as aluminum, produce the best cakes. Avoid shiny metals, such as stainless steel, which reflect the heat, and dark metal pans, which absorb heat too quickly. When it comes to baking bread, choose heavy aluminum or dark metal pans for the best texture and a well-browned crust.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e11378"
    }
  }, [_c('i', [_c('b', [_vm._v("How to Measure a Pan")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e11438"
    }
  }, [_vm._v("To measure a baking dish or pan, measure across the top of the dish from inside edge to inside edge. Measure the depth on the inside of the dish from the bottom to the rim.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e11598"
    }
  }, [_c('i', [_c('b', [_vm._v("Essential Bakeware Roundup")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e11648"
    }
  }, [_c('b', [_c('i', [_vm._v("Baking dish ")])]), _vm._v("A large, fairly shallow oval or rectangular dish with sides about 2 inches high; usually glass or ceramic. It’s good to have a variety of sizes, but 10\" by 15\", 13\" by 9\", and 11\" by 7\" are the most commonly used.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e11868"
    }
  }, [_c('b', [_c('i', [_vm._v("Baking pan ")])]), _vm._v("Similar to a baking dish but made of metal; the sides are 1½ to 2 inches high. You’ll want an 8-inch square, a 9-inch square, and a 13\" by 9\" pan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e12088"
    }
  }, [_c('b', [_c('i', [_vm._v("Bundt pan ")])]), _vm._v("Sometimes called a fluted tube pan. A 10-inch, 12-cup size is good for most needs.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0008_001",
      "src": "Images/9781618371621_0008_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e12178"
    }
  }, [_c('i', [_vm._v("Basic baking and roasting pans: metal loaf pan, oval baking dish, jelly-roll pan, cookie sheet, roasting pan and rack, round cake pan, square baking pan, springform pan")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e12338"
    }
  }, [_c('b', [_c('i', [_vm._v("Cake pan ")])]), _vm._v("Layer cakes are usually baked in 8- or 9-inch round pans (you’ll need two or three of each); baking pans are used for rectangular and square cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e12478"
    }
  }, [_c('b', [_c('i', [_vm._v("Casserole ")])]), _vm._v("Round, oval, square, or rectangular, this lidded dish can be glass, ceramic, or enameled metal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e12578"
    }
  }, [_c('b', [_c('i', [_vm._v("Cookie sheets ")])]), _vm._v("For the best air circulation and for even browning, choose shiny, heavy, metal cookie sheets with one or two slightly raised sides. Double-thick insulated pans protect against overbrowning. Nonstick surfaces are another option.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e12808"
    }
  }, [_c('b', [_c('i', [_vm._v("Custard cups ")])]), _vm._v("Purchase glass cups or ceramic ramekins with a 6-ounce capacity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e12908"
    }
  }, [_c('b', [_c('i', [_vm._v("Jelly-roll pan ")])]), _vm._v("Use a standard aluminum 15½\" by 10½\" pan for jelly-roll cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e13188"
    }
  }, [_c('b', [_c('i', [_vm._v("Loaf pan ")])]), _vm._v("Standard sizes are 9\" by 5\" and 8½\" by 4½\". There is a substantial volume difference between the two.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e13488"
    }
  }, [_c('b', [_c('i', [_vm._v("Muffin tins ")])]), _vm._v("To bake muffins and cupcakes, use standard 2½\" by 1¼\" muffin-pan cups; 1¾\" by 1\" mini muffin-pan cups are nice to have too.")]), _vm._v(" "), _c('div', {
    staticClass: "side"
  }, [_c('p', {
    staticClass: "sidebarh3",
    staticStyle: {
      "color": "#8A4117"
    },
    attrs: {
      "id": "d7e13949"
    }
  }, [_c('b', [_vm._v("HIGH-ALTITUDE COOKING")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e13999"
    }
  }, [_vm._v("The recipes in this book have been perfected for use at sea level. At higher altitudes, adjustments in the cooking time, temperature, and ingredients could be necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx",
    attrs: {
      "id": "d7e14139"
    }
  }, [_vm._v("At sea level, water boils at 212°F. With each additional 500 feet of altitude, the boiling point drops 1°F. Even though the boiling point is lower, it takes longer to generate the heat required to cook food. Therefore, at high altitudes, foods boiled in water (such as pasta and beans) will take longer to come to a boil and will require longer cooking times than our recipes suggest. The processing times for canning foods and the blanching times for freezing vegetables will vary, too.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx",
    attrs: {
      "id": "d7e14589"
    }
  }, [_vm._v("At high altitudes, cake recipes may need slight adjustments in the proportions of flour, leavening, liquid, eggs, etc. These adjustments will vary from recipe to recipe, and no set guidelines can be given. Many cake mixes now carry special directions on the label for high-altitude preparation.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx",
    attrs: {
      "id": "d7e14819"
    }
  }, [_vm._v("High altitudes can also affect the rising of doughs and batters, deep-frying, candy making, and other aspects of food preparation. For complete information and special recipes for your area, call or write to the home agent at your county cooperative extension office or to the home economics department of your local utility company or state university.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e15089"
    }
  }, [_c('b', [_c('i', [_vm._v("Pie plate ")])]), _vm._v("The standard size is 9\" by 1\"; deep-dish pie plates are 9½\" by 1½\" or 9½\" by 2\". Glass, dark metal, and aluminum pans yield crisp, nicely browned piecrusts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e15509"
    }
  }, [_c('b', [_c('i', [_vm._v("Roasting pan ")])]), _vm._v("A large deep pan typically made of stainless steel, enameled steel, or aluminum. A rectangular roasting pan with a rack is the most useful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e15639"
    }
  }, [_c('b', [_c('i', [_vm._v("Spring form pan ")])]), _vm._v("9\" by 3\" and 10\" by 2½\" are the ones most often called for.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e15829"
    }
  }, [_c('b', [_c('i', [_vm._v("Tart pan ")])]), _vm._v("A shallow metal pan with fluted sides and a removable bottom that comes in many shapes and sizes: 9\" by 1\" and 11\" by 1\" round pans are the most common.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e15999"
    }
  }, [_c('b', [_c('i', [_vm._v("Tube pan ")])]), _vm._v("Comes in 9- and 10-inch diameters.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e16099"
    }
  }, [_c('b', [_vm._v("UTENSIL CENTRAL")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e16149"
    }
  }, [_vm._v("In addition to pots and pans, every kitchen needs other helpful tools. Here are some we find indispensable:")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e16259"
    }
  }, [_c('b', [_c('i', [_vm._v("Bristle brushes ")])]), _vm._v("Use one for cleaning pots and one for scrubbing vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e16359"
    }
  }, [_c('b', [_c('i', [_vm._v("Colander ")])]), _vm._v("Choose a large colander with a stable footed base; the more holes it has, the more quickly food can drain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e16499"
    }
  }, [_c('b', [_c('i', [_vm._v("Cooling racks ")])]), _vm._v("If you bake a lot of cookies, you should have at least two large wire racks. Bakers who like to make layer cakes should have three or four small round racks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e16669"
    }
  }, [_c('b', [_c('i', [_vm._v("Corkscrew ")])]), _vm._v("A tool used to remove the corks from wine bottles. They are available at most kitchenware stores in a range of prices.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e16809"
    }
  }, [_c('b', [_c('i', [_vm._v("Cutting boards ")])]), _vm._v("Plastic boards are lightweight and easy to clean in the dishwasher, but wooden boards are extremely durable and don’t attract or retain any more bacteria than plastic ones.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e16979"
    }
  }, [_c('b', [_c('i', [_vm._v("Grater ")])]), _vm._v("This flat or box-shaped tool can grate (small holes), shred (large holes), or slice (large slots). We love Microplane"), _c('sup', [_vm._v("®")]), _vm._v(" graters for their sharpness and ease of use.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e17179"
    }
  }, [_c('b', [_c('i', [_vm._v("Measuring cups ")])]), _vm._v("For liquids, use clear glass or plastic cups with pouring spouts. It’s useful to have two sizes: a 1-cup measure for smaller amounts and a 2- or 4-cup measure for larger amounts. To measure dry ingredients accurately, use metal or plastic cups that come in nested sets of ¼ cup, ⅓ cup, ½ cup, and 1 cup.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e17659"
    }
  }, [_c('b', [_c('i', [_vm._v("Measuring spoons ")])]), _vm._v("Come in nesting sets; stainless-steel spoons are the most durable. Most sets include ¼ teaspoon, ½ teaspoon, 1 teaspoon, and 1 tablespoon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e17949"
    }
  }, [_c('b', [_c('i', [_vm._v("Mixing bowls ")])]), _vm._v("Stainless-steel bowls are the most versatile because they react quickly to changes in temperature. Glass or ceramic bowls work well to insulate rising yeast dough.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e18119"
    }
  }, [_c('b', [_c('i', [_vm._v("Rolling pins ")])]), _vm._v("Heavy pins, either hardwood or marble, work best for rolling out dough.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e18219"
    }
  }, [_c('b', [_c('i', [_vm._v("Sieve/strainer ")])]), _vm._v("A wire sieve can be used to sift ingredients or strain liquids. Buy a few sizes with different mesh gauges.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e18359"
    }
  }, [_c('b', [_c('i', [_vm._v("Spatulas ")])]), _vm._v("To turn food, use heatproof or metal spatulas (pancake turners). Rubber spatulas are used for mixing and folding; they’re not heatproof. Silicon spatulas are heatproof. And a long, narrow metal spatula is a must for frosting cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e186010"
    }
  }, [_c('b', [_c('i', [_vm._v("Thermometers ")])]), _vm._v("Meat thermometers are vital when roasting meats and poultry, and many options are available. Instant-read thermometers, which register up to 220°F, are very accurate. Probe-type thermometers give a digital reading on a unit that is placed outside the oven. Candy thermometers register temperatures up to 400°F and can be used for candy making and deep-frying. An oven thermometer is the best way to accurately check the temperature of an oven, because control dials and thermostats are notoriously inaccurate. Optional, but nice to have, are freezer and refrigerator thermometers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e190110"
    }
  }, [_c('b', [_c('i', [_vm._v("Tongs ")])]), _vm._v("Spring-action tongs are the best for picking up foods and for turning meats without piercing them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e191210"
    }
  }, [_c('b', [_c('i', [_vm._v("Vegetable peeler ")])]), _vm._v("Swivel-blade peelers remove less peel than fixed-blade peelers; they conform to the shape of the food.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e192510"
    }
  }, [_c('b', [_c('i', [_vm._v("Whisk ")])]), _vm._v("Use the right whisk for the job. A medium-size whisk is good for sauces, vinaigrettes, and batters. Flat paddle-shaped whisks are perfect for getting into the corners of roasting pans when making pan gravies. Large balloon-shaped whisks are ideal for beating air into heavy cream or egg whites."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e195310"
    }
  }, [_c('i', [_c('b', [_vm._v("Nice-to-Have Extras")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d9t01210"
    }
  }, [_c('b', [_c('i', [_vm._v("Adjustable-blade slicer ")])]), _vm._v("Use to slice, cut into matchstick strips, and waffle-cut. Adjustable-blade slicers range from the classic and pricey metal mando-line to lightweight plastic models that do a great job for much less money.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e197610"
    }
  }, [_c('b', [_c('i', [_vm._v("Apple corer ")])]), _vm._v("This cylindrical tool neatly cores whole apples as well as pears. Buy the largest size because it will easily remove all the core.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e199010"
    }
  }, [_c('b', [_c('i', [_vm._v("Egg beater ")])]), _vm._v("This hand-powered mixer can also be used for whipping cream. It’s low-tech but useful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e200110"
    }
  }, [_c('b', [_c('i', [_vm._v("Ice-cream maker ")])]), _vm._v("Available in manual and electric models; some have insulated liners that must be frozen overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e201510"
    }
  }, [_c('b', [_c('i', [_vm._v("Juicer ")])]), _vm._v("Use for extracting fruit and vegetable juices. One of the most practical models is a simple ridged cone that easily juices citrus fruits. Small electric versions are great when you need a large quantity of juice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e203410"
    }
  }, [_c('b', [_c('i', [_vm._v("Kitchen scissors ")])]), _vm._v("For cutting kitchen string, snipping fresh herbs, and trimming artichoke leaves. Shears, which are larger and spring-loaded, make cutting up poultry simple. Buy sturdy models made of stainless steel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e205810"
    }
  }, [_c('b', [_c('i', [_vm._v("Melon baller ")])]), _vm._v("Besides scooping perfect globes of melon (and potatoes), this tool neatly cores halved apples and pears.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e207110"
    }
  }, [_c('b', [_c('i', [_vm._v("Mortar and pestle ")])]), _vm._v("Use for grinding spices and herbs. You crush with the pestle (the batlike tool) in the mortar (the bowl).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e208510"
    }
  }, [_c('b', [_c('i', [_vm._v("Pastry bag ")])]), _vm._v("For decorating cakes and pies, forming spritz cookies, and creating beautifully shaped pastries. Disposable plastic pastry bags don’t retain odors and flavors as plastic-lined canvas bags do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e210410"
    }
  }, [_c('b', [_c('i', [_vm._v("Pastry blender ")])]), _vm._v("This tool’s metal wires easily cut cold fat into flour for tart dough, pastry dough, biscuits, and scones.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e211810"
    }
  }, [_c('b', [_c('i', [_vm._v("Pastry brush ")])]), _vm._v("Use to brush dough with melted butter or beaten egg and to apply glazes; also great for dusting excess flour from dough. When buying, look for well-anchored natural bristle brushes in widths of 1 to 1½ inches.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e214710"
    }
  }, [_c('b', [_c('i', [_vm._v("Potato masher ")])]), _vm._v("Perfect for cooked potatoes and other root vegetables and for turning cooked beans into a chunky puree.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e216110"
    }
  }, [_c('b', [_c('i', [_vm._v("Ruler ")])]), _vm._v("Keep a ruler in the kitchen for measuring pans and pastry shapes as well as for other tasks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e217110"
    }
  }, [_c('b', [_c('i', [_vm._v("Salad spinner ")])]), _vm._v("Uses centrifugal force to dry greens, preventing dressed salads from getting watered down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e218210"
    }
  }, [_c('b', [_c('i', [_vm._v("Skewers ")])]), _vm._v("A must for kabobs. Always soak wooden and bamboo skewers in water for 30 minutes before using to prevent them from burning on the grill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e219610"
    }
  }, [_c('b', [_c('i', [_vm._v("Steamer ")])]), _vm._v("The collapsible metal style easily fits into various-sized pots and pans. There is also a version that consists of a saucepan with a perforated bowl-like insert that allows the steam to penetrate. Bamboo steamers fit into woks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e221610"
    }
  }, [_c('b', [_c('i', [_vm._v("Zester ")])]), _vm._v("Pulled across the peel of citrus fruit, it removes the colorful, flavorful outer layer, leaving the bitter pith behind."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e223110"
    }
  }, [_c('i', [_c('b', [_vm._v("Sharpening Up on Knives")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e223610"
    }
  }, [_vm._v("The importance of good knives cannot be overemphasized. Poorly made knives make cutting and chopping tiresome work, while good knives will enable you to whip through these jobs with ease. If you take good care of your fine knives, they’ll last a lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e225510"
    }
  }, [_vm._v("High-carbon stainless steel, an alloy that contains a large proportion of carbon, makes excellent knives that sharpen well. Some cooks prefer carbon-steel knives because they hold a very sharp edge, but they also corrode and stain easily. Knives that purport to never need sharpening have two drawbacks: The blades are finely serrated, so their ridges can tear food instead of cutting it. When the knives eventually do need sharpening, it isn’t possible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e229011"
    }
  }, [_vm._v("Before buying a knife, hold it in your hand to see if it feels comfortable. The best knives are made of a solid piece of metal (called the tang) that goes all the way through the handle. The extra weight of the tang gives a knife better balance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e230811"
    }
  }, [_vm._v("Using the proper knife for each kitchen chore is more efficient and will make the job easier, ultimately saving you time in preparation. These knives should be in every well-run kitchen:")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e232511"
    }
  }, [_vm._v("• Chef ’s knife (for slicing, chopping, and mincing)")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d9t01311"
    }
  }, [_vm._v("• Paring knife (for fruits and vegetables)")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d9t01411"
    }
  }, [_vm._v("• Long serrated knife (for slicing breads, cakes, and thin-skinned fruits and vegetables)")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d9t01511"
    }
  }, [_vm._v("• Carving knife (for slicing meats). It often comes in a set with a carving fork.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0011_001",
      "src": "Images/9781618371621_0011_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e235011"
    }
  }, [_c('i', [_vm._v("Basic measuring cups and spoons: 1-, 2-, and 4-cup glass measuring cups, set of dry measuring cups, set of measuring spoons ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e235811"
    }
  }, [_vm._v("• Thin-bladed boning knife (for trimming fat and cutting poultry and meat)")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d9t01711"
    }
  }, [_vm._v("• Slicing knife (for cutting thin slices of meat). It has a scalloped edge and a round tip, so you won’t poke a hole in the roast")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d9t01811"
    }
  }, [_vm._v("• Heavy cleaver (for cutting up poultry)")]), _vm._v(" "), _c('p', {
    staticClass: "h1l",
    staticStyle: {
      "color": "#c15b49"
    },
    attrs: {
      "id": "d7e238011"
    }
  }, [_c('b', [_vm._v("COOKING BASICS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e238511"
    }
  }, [_vm._v("If you master just a few fundamental cooking skills, you will be assured success in the kitchen. Measuring ingredients may be a simple task, but if performed carelessly, it may mean the difference between success and failure. Learn how to chop, slice, and cut properly and your meal preparation time will be reduced. And remember, as with other skills, practice makes perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e241111"
    }
  }, [_c('b', [_vm._v("MEASURING BASICS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e241611"
    }
  }, [_vm._v("Measure ingredients carefully, and you’ll get consistent results each time you prepare a recipe. Every kitchen needs liquid measuring cups, dry measuring cups, and measuring spoons.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e243211"
    }
  }, [_vm._v("• For liquids, use clear glass measuring cups with pouring spouts. Place the cup on a level surface and add the desired amount of liquid; bend down to check the accuracy of the measure at eye level (do not lift up the cup).")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e244611"
    }
  }, [_vm._v("• For dry ingredients, use standard-size metal or plastic cups that can be leveled off.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e245511"
    }
  }, [_vm._v("• Nesting sets of graduated measuring spoons are used to measure both liquid and dry ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0011_002",
      "src": "Images/9781618371621_0011_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e246811"
    }
  }, [_vm._v("We use the “spoon-and-sweep” method for measuring dry ingredients such as flour, sugar, and cocoa. To measure flour, for example, stir it with a fork or whisk to aerate it (flour tends to pack down during storage). Lightly spoon the flour into a dry measuring cup to overflowing, then level it off with the straight edge of a knife or narrow metal spatula: Don’t pack the flour or shake the cup. If a recipe calls for 1 cup sifted flour, sift the flour, then spoon it into the cup. If you need 1 cup flour, sifted, measure the flour and then sift. Do not “dip and sweep” (use the measuring cup to scoop the flour); it packs too much flour into the cup.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e251612"
    }
  }, [_vm._v("Butter and margarine come in premarked sticks, so there’s no need to use a measuring cup. Use the markings on the wrapper to measure the desired amount, then cut it off. One 4-ounce (¼ pound) stick of butter or margarine equals 8 tablespoons or ½ cup.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e255012"
    }
  }, [_vm._v("Ingredients such as vegetable shortening, butter, and brown sugar, should be firmly packed (pressed) into dry measuring cups or spoons and then leveled off.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e256212"
    }
  }, [_vm._v("Before measuring sticky ingredients, such as corn syrup or molasses, coat the measuring cup or spoon with vegetable oil or nonstick cooking spray, so the item can slide out easily.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e257712"
    }
  }, [_vm._v("If you have any doubts about the volume of a baking dish or casserole, pour a measured amount of water into the dish, right up to the top. Or double-check a baking pan’s dimensions with a ruler; even a 1-inch difference can affect your baking success.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e259712"
    }
  }, [_c('b', [_vm._v("CUTTING BASICS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e260212"
    }
  }, [_vm._v("For the best results, use a chef ’s knife, and sharpen it on a steel before each use. To prevent the cutting board from slipping, place a damp towel underneath. Hold the knife handle in your right hand near the blade. Your thumb should be on the left side of the handle and your fingers close together and wrapped around the other side of the handle.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0012_001",
      "src": "Images/9781618371621_0012_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e264212"
    }
  }, [_vm._v("In this book, we coarsely chop, slice, cube, cut into matchstick strips, finely chop, and mince. Here’s how:")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e265012"
    }
  }, [_c('b', [_c('i', [_vm._v("Coarsely chop ")])]), _vm._v("To cut food into ½- to ¾-inch irregular pieces: When chopping, the tip of the knife remains on the cutting board; the knife handle is raised and lowered in a rocking motion while the knife is moved from left to right. If necessary, tuck under the fingers of your left hand and carefully push the food toward the blade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e269312"
    }
  }, [_c('b', [_c('i', [_vm._v("Chop ")])]), _vm._v("To cut food into small irregular pieces about the size of peas: Roughly cut up the food, then move the knife through the food until you have the desired size.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e271212"
    }
  }, [_c('b', [_c('i', [_vm._v("Finely chop ")])]), _vm._v("To chop food into very small irregular pieces, less than ¼ inch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e273112"
    }
  }, [_c('b', [_c('i', [_vm._v("Mince ")])]), _vm._v("To cut into tiny irregular pieces, less than ⅛ inch. We use this term only for ginger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e274812"
    }
  }, [_c('b', [_c('i', [_vm._v("Cube ")])]), _vm._v("To cut into ½-inch blocks: First cut the food lengthwise into ½-inch-thick slices. Stack the slices and cut into ½-inch-wide sticks. Then cut crosswise into ½-inch cubes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e279812"
    }
  }, [_c('b', [_c('i', [_vm._v("Matchstick strips ")])]), _vm._v("First, cut the food into slices 2 inches long and ⅛ inch thick. Stack the slices; cut lengthwise into ⅛-inch-wide sticks.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0012_002",
      "src": "Images/9781618371621_0012_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1l",
    staticStyle: {
      "color": "#c15b49"
    },
    attrs: {
      "id": "d7e283312"
    }
  }, [_c('b', [_vm._v("FOOD SAFETY AND STORAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e283812"
    }
  }, [_vm._v("Use these guidelines to help keep the food in your kitchen wholesome and safe to eat.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e284812"
    }
  }, [_c('b', [_vm._v("RULES OF FOOD SAFETY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e285412"
    }
  }, [_c('b', [_c('i', [_vm._v("Keep It Clean")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e285912"
    }
  }, [_vm._v("Good old-fashioned cleanliness is the best safeguard against harmful bacteria. Keep a clean kitchen. Always wash and dry your hands before handling food. Frequently wash kitchen towels, dishcloths, and sponges. Rinse fruits and vegetables thoroughly before eating. Sterilize cutting boards once a week in a solution of 1 tablespoon bleach per 1 gallon water.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e288912"
    }
  }, [_c('i', [_c('b', [_vm._v("Avoid Cross-Contamination")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e289412"
    }
  }, [_vm._v("Don’t put cooked meat (or any ready-to-eat food) on a plate that has been in contact with raw meat, poultry, or fish. It’s a good idea to have several cutting boards: one for raw meats, poultry, and fish; one for vegetables and cheese; and perhaps a third for fruits, nuts, and chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e292213"
    }
  }, [_c('b', [_c('i', [_vm._v("Cook It Right")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e292713"
    }
  }, [_vm._v("To kill harmful bacteria that may be present in raw eggs, fish, poultry, and meat, it’s essential to cook these foods thoroughly. The United States Department of Agriculture recommends cooking them to at least 160°F. At this temperature, however, food (especially meat) may be cooked beyond your preference. If you cook it less, some risk is involved, so the choice is ultimately a personal one. An instant-read thermometer is the easiest way to check for doneness. To check visually, follow these guidelines: Cook red meat to at least medium-rare, pork until the juices run clear and the meat retains just a trace of pink, poultry until the juices run clear, fish just until opaque throughout, and egg yolks and whites until thickened and set. Always cook ground meat until no pink remains. When cooking egg-based sauces, be sure the final temperature is no lower than 160°F.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e298113"
    }
  }, [_c('i', [_c('b', [_vm._v("Keep Hot Foods Hot and Cold Foods Cold")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e298613"
    }
  }, [_vm._v("The safe zones for storing food are below 40°F and above 140°F. Keep food below or above these temperatures, and you’ll discourage bacterial growth (bacteria love a moist, warm environment). Don’t leave food out at room temperature for longer than two hours. In hot weather, protein foods such as chicken, egg salad, or any food containing mayonnaise should not be left out of the refrigerator for more than one hour. It’s also unwise to cook food in stages. For example, don’t partially cook fish, poultry, or meat, then return to it later to finish cooking. Even when food is stored in the refrigerator between the cooking stages, safe temperatures may not be maintained and bacteria could develop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e303113"
    }
  }, [_c('b', [_c('i', [_vm._v("Treat Leftovers with Respect")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e303713"
    }
  }, [_vm._v("Refrigerate leftovers as soon as possible. Divide large amounts among smaller containers for quicker cooling. Date all leftovers so you know how long you’ve had them. If you have any doubt about a food’s freshness, throw it out.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e305913"
    }
  }, [_c('b', [_vm._v("REFRIGERATOR KNOW-HOW")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e306413"
    }
  }, [_vm._v("Don’t take your refrigerator for granted. Help it do its job by following a few simple rules:")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e307413"
    }
  }, [_vm._v("Be sure the temperature of your refrigerator remains between 33° and 40°F; use a refrigerator thermometer for extra insurance. To prevent spoilage, store foods on a rotating basis: Place newly stored items at the back of the shelves and move older items to the front.")]), _vm._v(" "), _c('div', {
    staticClass: "side"
  }, [_c('p', {
    staticClass: "sidebarh3",
    staticStyle: {
      "color": "#8A4117"
    },
    attrs: {
      "id": "d7e308513"
    }
  }, [_c('b', [_vm._v("HOW LONG WILL IT KEEP?")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e309213"
    }
  }, [_vm._v("Foods frozen for longer than the recommended times aren’t harmful—they just won’t be at their peak flavor and texture.")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('colgroup', [_c('col'), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', [_c('b', [_vm._v("FOOD ")])])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("TIME IN FREEZER "), _c('br'), _vm._v(" (0°F) ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Milk ")]), _vm._v(" "), _c('td', [_vm._v("3 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Butter ")]), _vm._v(" "), _c('td', [_vm._v("6 to 9 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cheese, hard (Cheddar, Swiss) ")]), _vm._v(" "), _c('td', [_vm._v("6 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cheese, soft (Brie, Bel Paese) ")]), _vm._v(" "), _c('td', [_vm._v("6 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cream, half-and-half ")]), _vm._v(" "), _c('td', [_vm._v("4 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sour cream ")]), _vm._v(" "), _c('td', [_vm._v("don’t feeze")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Eggs (raw yolks, whites) ")]), _vm._v(" "), _c('td', [_vm._v("1 year")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Frankfurters (opened or unopened packages) ")]), _vm._v(" "), _c('td', [_vm._v("1 to 2 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Luncheon meats (opened or unopened packages) ")]), _vm._v(" "), _c('td', [_vm._v("1 to 2 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bacon ")]), _vm._v(" "), _c('td', [_vm._v("1 month")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sausage, raw, links or patties ")]), _vm._v(" "), _c('td', [_vm._v("1 to 2 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ham, fully cooked (whole, half, slices) ")]), _vm._v(" "), _c('td', [_vm._v("1 to 2 months\n")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Ground or stew meat ")]), _vm._v(" "), _c('td', [_vm._v("3 to 4 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Steaks ")]), _vm._v(" "), _c('td', [_vm._v("6 to 12 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Chops ")]), _vm._v(" "), _c('td', [_vm._v("3 to 6 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Roasts ")]), _vm._v(" "), _c('td', [_vm._v("4 to 12 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Chicken or turkey, whole ")]), _vm._v(" "), _c('td', [_vm._v("1 year")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Chicken or turkey, pieces ")]), _vm._v(" "), _c('td', [_vm._v("9 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Casseroles, cooked, poultry ")]), _vm._v(" "), _c('td', [_vm._v("4 to 6 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Casseroles, cooked,meat ")]), _vm._v(" "), _c('td', [_vm._v("2 to 3 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Soups and stews ")]), _vm._v(" "), _c('td', [_vm._v("2 to 3 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fish, lean (cod, flounder, haddock) ")]), _vm._v(" "), _c('td', [_vm._v("6 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fish, fatty (bluefish,mackerel, salmon) ")]), _vm._v(" "), _c('td', [_vm._v("2 to 3 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fish, cooked ")]), _vm._v(" "), _c('td', [_vm._v("4 to 6 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Fish, smoked ")]), _vm._v(" "), _c('td', [_vm._v("2 months in "), _c('br'), _vm._v(" vacuum pack")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Shrimp, scallops, squid,")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("shucked clams,mussels, oysters ")]), _vm._v(" "), _c('td', [_vm._v("3 to 6 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pizza ")]), _vm._v(" "), _c('td', [_vm._v("1 to 2 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Breads and rolls, yeast ")]), _vm._v(" "), _c('td', [_vm._v("3 to 6 month")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Breads, quick ")]), _vm._v(" "), _c('td', [_vm._v("2 to 3 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cakes, unfrosted ")]), _vm._v(" "), _c('td', [_vm._v("3 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cheesecakes ")]), _vm._v(" "), _c('td', [_vm._v("2 to 3 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cookies, baked ")]), _vm._v(" "), _c('td', [_vm._v("3 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cookie dough, raw ")]), _vm._v(" "), _c('td', [_vm._v("2 to 3 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pies, fruit, unbaked ")]), _vm._v(" "), _c('td', [_vm._v("8 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pies, custard or meringue-topped ")]), _vm._v(" "), _c('td', [_vm._v("don’t freeze")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Piecrust, raw ")]), _vm._v(" "), _c('td', [_vm._v("2 to 3 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nuts, salted ")]), _vm._v(" "), _c('td', [_vm._v("6 to 8 months")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nuts, unsalted ")]), _vm._v(" "), _c('td', [_vm._v("9 to 12 months ")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e311914"
    }
  }, [_vm._v("Store meat, fish, and poultry on a plate to catch any drips; if you don’t plan to cook them within two days, freeze them immediately. Never store eggs in the open egg compartment in the refrigerator door; it’s too warm. Eggs should be kept in their original container to prevent them from absorbing the odors of other foods. For this same reason, store cheese, cream, milk, yogurt, margarine, and butter tightly closed in their containers or packaging or wrap airtight.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e315214"
    }
  }, [_c('b', [_vm._v("PANTRY STORAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e315714"
    }
  }, [_vm._v("Unless otherwise noted, these pantry staples fare best in a cool, dry place. For more information on ingredients such as flour, pasta, and grains, see the specific chapter introductions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e317314"
    }
  }, [_c('b', [_c('i', [_vm._v("Baking powder ")])]), _vm._v("Once opened, it will keep for up to six months. To test its effectiveness, add ½ teaspoon to ½ cup warm water; it should bubble vigorously.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e320314"
    }
  }, [_c('b', [_c('i', [_vm._v("Bread crumbs ")])]), _vm._v("Store dried bread crumbs for up to six months or, for better flavor, refrigerate for up to two years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e321714"
    }
  }, [_c('b', [_c('i', [_vm._v("Honey ")])]), _vm._v("Lasts indefinitely; if it crystallizes, remove the lid and place the jar in a bowl of hot water. Stir until the crystals dissolve.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e323114"
    }
  }, [_c('b', [_c('i', [_vm._v("Hot pepper sauce ")])]), _vm._v("Refrigerate after opening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e323814"
    }
  }, [_c('b', [_c('i', [_vm._v("Olive oil ")])]), _vm._v("Keep in a cool, dark place for up to six months. Don’t buy more than you can use; it can turn rancid, especially if stored in a warm place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e325214"
    }
  }, [_c('b', [_c('i', [_vm._v("Pancake syrup ")])]), _vm._v("It will keep for up to nine months (if stored longer, the syrup will thin and the flavor will weaken).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e326614"
    }
  }, [_c('b', [_c('i', [_vm._v("Peanut butter ")])]), _vm._v("Unopened it will hold for a year in your cupboard. Refrigerate after opening to keep it from becoming rancid.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e328014"
    }
  }, [_c('b', [_c('i', [_vm._v("Soy sauce ")])]), _vm._v("Unopened it will keep for one year. Once opened, refrigerate to keep for an additional year.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e329214"
    }
  }, [_c('b', [_c('i', [_vm._v("Spices and dried herbs ")])]), _vm._v("Store in opaque containers in a cool, dark place (not near the stove) for up to one year. After that, herbs and spices begin to lose their flavor. It’s a good idea to write the date of purchase on the label. Sniff before using: If the aroma is weak, discard and buy a new supply.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e331614"
    }
  }, [_c('b', [_c('i', [_vm._v("Vegetable oil ")])]), _vm._v("Store in a cool, dark place for up to six months.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e332814"
    }
  }, [_c('b', [_c('i', [_vm._v("Vinegar ")])]), _vm._v("Unopened it will keep indefinitely. The sediment that sometimes appears is harmless; strain off the vinegar, if you wish. Once opened store for up to six months. Vinegar with added flavorings, such as herbs, should be strained into a clean bottle as soon as the vinegar level drops below the top of the ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e335414"
    }
  }, [_c('b', [_vm._v("STORING FRESH HERBS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e335914"
    }
  }, [_vm._v("Most fresh herbs are highly perishable, so buy them in small quantities. To store for a few days, immerse the roots or stems in 2 inches of water. Cover with a plastic bag; refrigerate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e337514"
    }
  }, [_vm._v("To dry fresh herbs (this works best with sturdy herbs like rosemary and thyme), rinse lightly and pat dry with paper towels. Hang them upside down, in bunches, in a dry, dark place. When the leaves become brittle (it typically takes from a few days up to one week), pick them off and discard the stems. Store the dried leaves in a tightly covered opaque container in a cool, dry place.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e339914"
    }
  }, [_vm._v("To freeze herbs, rinse lightly, pat dry, and remove the stems. Place them in plastic containers or heavy-duty zip-tight plastic bags. When frozen, herbs darken, but their flavor remains. There’s no need to thaw frozen herbs; add them directly to the pot. Or place a few herbs (leaves only) in each section of an ice cube tray. Add enough water to cover; freeze. Unmold and store the cubes in heavy-duty zip-tight plastic bags. Add the cubes to simmering soups, sauces, or stews.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e343414"
    }
  }, [_c('b', [_vm._v("TAKING FOOD ON THE ROAD")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e343914"
    }
  }, [_vm._v("Whenever food is removed from the refrigerator, it can easily warm to temperatures that encourage bacterial growth. But with some planning, you can avoid potential problems.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e345514"
    }
  }, [_vm._v("For picnics, use two small coolers rather than one large one. Use one cooler for nonperishables, such as fruit and beverages, and the other for perishable items, such as meats, poultry, salads, and cheese. Remember: A cooler cannot make foods colder than they already are, so chill foods thoroughly before placing them in the cooler. To preserve the chill, don’t open the lid for longer or more often than necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e348414"
    }
  }, [_vm._v("Double-wrap meat and poultry in zip-tight plastic bags so the juices don’t leak out and contaminate other foods. Pack perishable items, like meat, next to the ice packs. Delicate items, such as green salads and slaws, should be stored away from the ice to prevent freezing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e350715"
    }
  }, [_vm._v("Thermal carrying bags are the most convenient way to transport hot foods, but a cooler can also maintain the temperature of hot foods for a few hours. If you are bringing a hot dish to a party, heat it until piping hot. Wrap the covered dish in a thick layer of newspaper to insulate it and keep the heat in, then place in a cooler that isn’t much bigger than the dish.")]), _vm._v(" "), _c('p', {
    staticClass: "h1l",
    staticStyle: {
      "color": "#c15b49"
    },
    attrs: {
      "id": "d7e353315"
    }
  }, [_c('b', [_vm._v("EATING WELL")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e353815"
    }
  }, [_vm._v("The message is simple: Eat well to stay well. The good news is that you don’t need a graduate degree in nutrition to eat healthfully on a daily basis. What follows are some guidelines and information to help you make informed decisions about what you and your family should eat to maintain a balanced diet.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e356115"
    }
  }, [_c('b', [_vm._v("DIETARY GUIDELINES FOR AMERICANS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e356915"
    }
  }, [_vm._v("• Consume a variety of nutrient-dense foods and beverages within the basic food groups. Choose foods that limit your intake of saturated and trans fats, cholesterol, added sugars, salt, and alcohol.")]), _vm._v(" "), _c('div', {
    staticClass: "side"
  }, [_c('p', {
    staticClass: "sidebarh3",
    staticStyle: {
      "color": "#8A4117"
    },
    attrs: {
      "id": "d7e358615"
    }
  }, [_c('b', [_vm._v("USING THE NUTRITIONAL VALUES"), _c('br'), _vm._v(" IN THIS BOOK")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e359415"
    }
  }, [_vm._v("At the bottom of each recipe, you’ll find nutritional information. To aid you in using this information, see “Nutrients: The Big Three” and “Understanding Food Labels” for the recommended daily nutrient levels. Aim to balance higher-fat recipes with leaner accompaniments. For example, serve lasagna with a green salad tossed with low fat dressing, skim milk, and fresh fruit for dessert.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e362315"
    }
  }, [_vm._v("• Our nutritional calculations do not include any optional ingredients or garnishes.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e363315"
    }
  }, [_vm._v("• When alternative ingredients are given (such as margarine), our calculations are based on the first item listed.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e364715"
    }
  }, [_vm._v("• Unless otherwise noted, whole milk has been used.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebarh3",
    staticStyle: {
      "color": "#8A4117"
    },
    attrs: {
      "id": "d7e365615"
    }
  }, [_c('b', [_vm._v("UNDERSTANDING FOOD LABELS")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e366115"
    }
  }, [_vm._v("Food labels help you make informed choices about the foods to include in your diet.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx",
    attrs: {
      "id": "d7e366915"
    }
  }, [_vm._v("The Percent Daily Values reflect the percentage of the recommended daily amount of a nutrient in a serving (based on 2,000 calories daily). You can “budget” your intake of nutrients by adding up these percentages. For example, the label below shows a food containing 13 percent of the daily value for fat. If the next food you eat has a 10percentdaily value for fat, you’ve already had 23 percent of your total fat allowance for the day. When it comes to fat, saturated fat, sodium, and cholesterol, try to keep the daily values below100percent.Aimfor 100 percent of fiber, vitamins A and C, calcium, and iron. (Other vitamins and minerals may also appear on labels.)")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx",
    attrs: {
      "id": "d7e371415"
    }
  }, [_vm._v("The Daily Values footnote includes a chart that shows some Daily Values for diets containing 2,000 and 2,500 calories. Your own daily values may be higher or lower. Food labels are required to have an ingredients list. The ingredients are listed in descending order according to their weight. This enables you to easily discern which food products contain larger amounts of ingredients that are healthful.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0015_001",
      "src": "Images/9781618371621_0015_001.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e375416"
    }
  }, [_vm._v("• Engage in regular physical activity and reduce sedentary activities to promote health, psychological well-being, and a healthy body weight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e376516"
    }
  }, [_vm._v("• Consume 2 cups of fruit and 2½ cups of vegetables (dark green and orange-colored vegetables, legumes, and starchy vegetables) each day for a 2,000-calorie diet, adjusting the amount as needed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e378916"
    }
  }, [_vm._v("• Consume three or more 1-ounce-equivalent servings of whole grains each day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e379716"
    }
  }, [_vm._v("• Consume 3 cups of fat-free or low-fat milk or equivalent dairy products per day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e380616"
    }
  }, [_vm._v("• Derive less than 10 percent of your calories from saturated fat and less than 300mg of cholesterol per day. Avoid trans fats.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e381916"
    }
  }, [_vm._v("• Keep your total fat intake between 20 and 35 percent of your calories, with most fats coming from polyunsaturated and monounsaturated sources, such as fish, nuts, and vegetable oils.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e383416"
    }
  }, [_vm._v("• Choose fiber-rich fruits, vegetables, and whole grains each day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e384316"
    }
  }, [_vm._v("• Consume less than 2,300mg (about 1 teaspoon) of sodium each day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e385116"
    }
  }, [_vm._v("• Women who choose to drink alcohol should limit themselves to one drink per day; men should limit themselves to no more than two drinks per day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e386316"
    }
  }, [_c('i', [_vm._v("For the complete recommendations, go to ")]), _c('a', {
    attrs: {
      "href": "http://www.health.gov/dietaryguidelines",
      "id": "d7e555",
      "target": "_blank"
    }
  }, [_vm._v("www.healthierus.gov/dieteryguidelines")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e387616"
    }
  }, [_c('b', [_vm._v("NUTRIENTS: "), _c('br'), _vm._v(" THE BIG THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e388616"
    }
  }, [_vm._v("Our bodies need three essential nutrients: carbohydrates, proteins, and fats.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e389616"
    }
  }, [_c('b', [_c('i', [_vm._v("Carbohydrates ")])]), _vm._v("The right kind of carbohydrates is the mainstay of a well-balanced diet. “Good” carbohydrates include fruits, vegetables, and whole grains. Carbohydrates come in many forms. They can be made up of dietary fiber, starch, or sugar. Diets rich in dietary fiber have been shown to have a reduced risk of coronary heart disease, among other benefits, and research indicates that whole-grain eaters are thinner than people who eat few whole-grain foods. Fiber, which is found in the bran layer of some grains, including whole wheat, is credited with some of the health benefits of whole grains. When whole wheat is processed to make white flour, the healthful bran layer is removed, along with the disease-fighting antioxidants in the bran. The latest government recommendations are that at least half of your grains should be whole grain (see “How to Spot a Whole Grain,”).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e395516"
    }
  }, [_vm._v("The starch and sugar in carbohydrates supply the body with the energy it needs for normal body functions, including brain functions, heartbeat, breathing, and digestion, as well as for exercise such as walking, running, and cycling. When carbohydrates are digested, they become blood sugar (glucose), which is then used as fuel in our bodies. In general, the less sugar you eat the better. This doesn’t, however, include the naturally occurring sugar in fruit, milk, or yogurt. You need to limit the "), _c('i', [_vm._v("added ")]), _vm._v("sugar that comes from sweeteners, including white sugar, brown sugar, honey, maple syrup, high-fructose corn syrup, dextrose, sucrose, fruit juice concentrate, and other sweeteners. Remember that starch is an important part of a balanced diet. Look for good carbs, such as whole-wheat pasta, whole-grain polenta, buckwheat, and oatmeal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e401716"
    }
  }, [_vm._v("Unfortunately, it is not always easy to tell if a product is a whole grain–rich food. So here are some clues:")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e402816"
    }
  }, [_vm._v("• Look for the word "), _c('i', [_vm._v("whole ")]), _vm._v("in the ingredients list.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e403716"
    }
  }, [_vm._v("• See where the whole grain falls in the list of ingredients. Remember that ingredients are listed in order of their weight: If a whole grain is listed first and is the only grain, there is a lot of whole grain in the product. If the first ingredient is "), _c('i', [_vm._v("wheat flour ")]), _vm._v(" (which is really white flour), followed by some sort of sweetener, then "), _c('i', [_vm._v("whole-wheat flour ")]), _vm._v("is not the dominant grain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e407016"
    }
  }, [_vm._v("• Check the amount of dietary fiber. In general, 100-percent whole-grain products should have at least 2 grams of fiber per ounce (29 grams) or per 80 calories; crackers at least 3 grams fiber per ounce; pasta at least 5 grams of fiber per 2 ounces dried. "), _c('i', [_vm._v("For more information, go to ")]), _c('a', {
    attrs: {
      "href": "http://www.wholegrainscouncil.org",
      "id": "d14e1284",
      "target": "_blank"
    }
  }, [_vm._v("www.wholegrainscouncil.org")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e409716"
    }
  }, [_c('b', [_c('i', [_vm._v("Proteins ")])]), _vm._v("The body needs protein to produce new body tissue. They are also a great weight-loss friend, as protein helps keep you feeling full for hours after eating. Too much protein, however, is unhealthy; it can stress the kidneys, and if it comes from fatty meat, it is also filling you with saturated fat. Beef, chicken, fish, pork, lamb, and other meats and tofu and other soy products are the richest sources of protein. Beans (black, pinto, etc.), lentils, cheese, milk, and yogurt are the next highest. A small amount of protein can also be found in grains, bread, and other starches and in vegetables. Ideally, your plate should look like this: half-filled with vegetables or fruits, a quarter with starches, and another quarter with protein-rich foods (and a little fat).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e415317"
    }
  }, [_c('b', [_c('i', [_vm._v("Fats ")])]), _vm._v("The government guideline for fat consumption is 20 to 35 percent of your total daily calories, which is a wide range. Much more important than the total fat is the amount of saturated and trans fat in your diet. Here’s what you need to know about these fats:")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e417317"
    }
  }, [_vm._v("When an excess of saturated fat is consumed, it raises your blood cholesterol level, increasing your risk of heart disease and stroke. Saturated fat is found naturally in foods, but it is especially concentrated in fatty animal-based foods, such as butter and chicken skin and in some oils, such as palm and coconut. Even “good” oils like olive and canola contain a little saturated fat, so you can’t avoid it entirely. For a heart-healthy diet you should derive less than 10 percent of your total calories from saturated fat, which is a maximum of 15 grams of saturated fat daily, based on a 1,500-calorie diet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e421317"
    }
  }, [_vm._v("Even worse than saturated fat is trans fat, which not only raises the LDL (“bad cholesterol”) but also lowers the HDL (“good cholesterol”). It is formed by a process called hydrogenation, which turns oils into semisolids like margarine and shortening. On the ingredients list these oils appear as partially hydrogenated oils or shortening and are reflected in the trans fat total on the Nutrition Facts label. It is important to keep your intake of trans fat low. Here are some tips:")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e424617"
    }
  }, [_vm._v("• Use canola or olive oil whenever possible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e425117"
    }
  }, [_vm._v("• Limit—or avoid—processed foods made with partially hydrogenated oils, or with oils high in saturated fat (palm, palm kernel, coconut) or with butter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e426317"
    }
  }, [_vm._v("• Use “0 trans” or “trans fat–free” margarine.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e427017"
    }
  }, [_c('b', [_vm._v("HOW TO INTERPRET "), _c('br'), _vm._v(" PACKAGE INFORMATION")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e427817"
    }
  }, [_vm._v("While the Nutrition Facts label can tell you a lot about a food, you need to check the ingredients list to see what you’re really eating. Is your breakfast cereal made with whole grains or does your favorite salad dressing contain oil that is high in saturated fat, for example.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e429717"
    }
  }, [_vm._v("By law, ingredients lists must be ordered by weight. The heaviest ingredient goes first, followed by the next heaviest, and so on. It is not a good sign if sugar is the first ingredient in a cereal or when bad fats like partially hydrogenated soybean and cottonseed oils are the third ingredient listed on a can of biscuit dough.")]), _vm._v(" "), _c('div', {
    staticClass: "side"
  }, [_c('p', {
    staticClass: "sidebarh3",
    staticStyle: {
      "color": "#8A4117"
    },
    attrs: {
      "id": "d7e432317"
    }
  }, [_c('b', [_vm._v("HOW TO SPOT A WHOLE GRAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "sidebartx1",
    attrs: {
      "id": "d7e432817"
    }
  }, [_vm._v("To help you when shopping for whole grains, here are the words you should look for in the ingredients list:")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('colgroup', [_c('col')]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', [_c('b', [_vm._v("IT’S A WHOLE GRAIN IF IT’S CALLED:")])])]), _vm._v(" "), _c('td', [_c('span', [_c('b', [_vm._v("IT’S NOT A WHOLE GRAIN IF IT’S CALLED:")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Brown (also black, red, purple) rice")]), _vm._v(" "), _c('td', [_vm._v("Corn flour or cornmeal")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Buckwheat")]), _vm._v(" "), _c('td', [_vm._v("Enriched flour")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bulgur (cracked wheat) ")]), _vm._v(" "), _c('td', [_vm._v("Multigrain (this means various grains, not necessarily whole) ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Millet")]), _vm._v(" "), _c('td', [_vm._v("Pumpernickel")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Quinoa")]), _vm._v(" "), _c('td', [_vm._v("Rice or rice flour")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sorghum")]), _vm._v(" "), _c('td', [_vm._v("Rye flour or rye")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Triticale")]), _vm._v(" "), _c('td', [_vm._v("Stone-ground wheat (it needs to say")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Whole-grain corn")]), _vm._v(" "), _c('td', [_vm._v("  “stone-ground whole wheat”) ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Whole oats and oatmeal")]), _vm._v(" "), _c('td', [_vm._v("Unbleached wheat flour")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Whole rye")]), _vm._v(" "), _c('td', [_vm._v("Wheat or wheat flour")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Whole spelt")]), _vm._v(" "), _c('td', [_vm._v("Wheat germ (not a whole grain but very good for you) ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Whole wheat")]), _vm._v(" "), _c('td', [_vm._v("Whole barley (pearl barley; not a whole grain")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Wild rice")]), _vm._v(" "), _c('td', [_vm._v("but very good for you) ")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e434118"
    }
  }, [_vm._v("Below is a list of common phrases found on many food packages:")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e435118"
    }
  }, [_c('b', [_c('i', [_vm._v("Cholesterol free or No cholesterol ")])]), _vm._v("Don’t be fooled by the words "), _c('i', [_vm._v("No cholesterol ")]), _vm._v("written across the label of a jar of peanut butter or bottle of canola oil. If you turn to the Nutrition Facts label, you’ll see that no brand of either food has cholesterol—and never did! Only foods of animal origin contain cholesterol. But manufacturers hope you don’t know that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e438318"
    }
  }, [_c('b', [_c('i', [_vm._v("Light ")])]), _vm._v("This word is used to describe fat content, taste, or color. If the manufacturer is describing the fat content as “light,” the product has at least 50 percent less fat than the original. The label must also say “50% less fat than our regular product.” “Light” olive oil, on the other hand, describes the oil’s color. The oil is as caloric as regular olive oil but has been processed to remove some of its flavor. A muffin mix can say “light and fluffy” as a way to describe its texture or consistency.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e441618"
    }
  }, [_c('b', [_c('i', [_vm._v("Low-fat or Fat-free ")])]), _vm._v("Low-fat products must contain 3 grams or less fat per serving and fat-free products must have less than 0.5 grams of fat per serving. But check the number of calories—that number could be very high. It is easy to gain lots of weight eating fat-free cookies because they are loaded with sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e444018"
    }
  }, [_c('b', [_c('i', [_vm._v("Low sodium or Light in sodium ")])]), _vm._v("This means that the sodium was cut by at least 50 percent over the original product. Be careful when using a “low” version of a super-high-sodium food such as soy sauce or soup. You can still end up consuming a lot of sodium. Check the numbers on the Nutrition Facts label.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e446518"
    }
  }, [_c('b', [_c('i', [_vm._v("Sugar-free, No added sugars, Without added sugars ")])]), _vm._v("A sugar-free chocolate candy may not contain a speck of sugar, but it’s still got plenty of fat and calories. Be sure to check out the Nutrition Facts label to know how many calories and grams of saturated fat you’re consuming.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e448918"
    }
  }, [_c('b', [_c('i', [_vm._v("Sweetened with fruit juice, Fruit juice sweetener, or Fruit juice concentrate ")])]), _vm._v("These sweeteners are made by reducing fruit juice—usually grape juice—into a sticky sweetener. These sweeteners are not nutritious; they are just like sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e451118"
    }
  }, [_c('b', [_vm._v("KEEP IT LIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e451618"
    }
  }, [_vm._v("In general, animal products are higher in fat than plant foods, but it’s not necessary to cut out all meat and dairy products to keep your fat intake reasonable. Low-fat dairy foods, lean and well-trimmed meat, and skinless poultry provide the same amounts of vitamins and minerals as their fattier counterparts. Skinless poultry, fish, dry beans, and split peas are the “slimmest” foods in this category. By removing the skin from poultry, you reduce the fat by almost one half. Most seafood is low in fat and also contains beneficial omega-3 oils, which have been linked to lowering blood cholesterol. Dry beans also provide the body with fiber, which is necessary for digestion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e456318"
    }
  }, [_vm._v("You can enjoy red meat if you choose lean cuts and trim away all the visible fat (marbled fat cannot be trimmed away). Here are some good choices:")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e457718"
    }
  }, [_vm._v("• Beef eye round, top round, tenderloin, top sirloin, flank steak, top loin, ground beef. Choose ground sirloin; it’s 90 to 93 percent lean.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e458818"
    }
  }, [_vm._v("• Veal cutlets (from the leg) and loin chops")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d9t01918"
    }
  }, [_vm._v("• Pork tenderloin, boneless top loin roast, loin chops, and boneless sirloin chops")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d9t02018"
    }
  }, [_vm._v("• Lamb, boneless leg (shank portions), loin roast, loin chops, leg cubes for kabobs")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e460618"
    }
  }, [_c('b', [_c('i', [_vm._v("Trimming the Fat ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e461118"
    }
  }, [_vm._v("Here are some suggestions to make trimming excess fat from your diet easier:")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e461918"
    }
  }, [_vm._v("• Choose lean cuts of meat and trim off all the visible fat before cooking. Remove skin from poultry before or after cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e463118"
    }
  }, [_vm._v("• Broil meat on a rack so the fat can drip away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e463618"
    }
  }, [_vm._v("• Substitute ground chicken or ground turkey for ground beef. Look for ground turkey breast or chicken breast; otherwise, it may contain skin and therefore have as much fat as ground beef.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e465118"
    }
  }, [_vm._v("• Substitute protein-packed dried legumes, like beans and lentils, for meat in casseroles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e466018"
    }
  }, [_vm._v("• Chill soups and stews overnight so you can remove all the hardened fat from the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e466818"
    }
  }, [_vm._v("• Be skimpy with fat. Use nonstick pans and nonstick cooking spray, or “sauté” in a small amount of broth or water. Don’t just pour oil into a skillet; it’s easy to add too much. Measure or use a pastry brush to coat pans with a thin layer of oil. When baking, coat pans with a spritz of nonstick cooking spray instead of oils or fats. (Kitchenware shops now carry oil sprayers you can fill with your favorite oil.)")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e470219"
    }
  }, [_vm._v("• Experiment with lowfat or skim milk, lowfat sour cream and cheese, and nonfat yogurt: they provide the same amounts of calcium and protein as the whole-milk varieties but with less fat or none at all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e471719"
    }
  }, [_vm._v("• When making dips, substitute nonfat plain yogurt for sour cream.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e472619"
    }
  }, [_vm._v("• Use fresh herbs and zesty seasonings liberally.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e473119"
    }
  }, [_vm._v("• Choose angel food cake instead of pound cake, especially when making cake-based desserts like trifle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e474019"
    }
  }, [_vm._v("• To reduce fat and cholesterol, you can substitute 2 egg whites for 1 whole egg in recipes, but don’t substitute egg whites for all the whole eggs when baking; the dessert will have better texture and flavor if you retain a yolk or two.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e475819"
    }
  }, [_vm._v("• Replace sour cream with buttermilk or yogurt in recipes for baked goods.")]), _vm._v(" "), _c('p', {
    staticClass: "h1l",
    staticStyle: {
      "color": "#c15b49"
    },
    attrs: {
      "id": "d7e476819"
    }
  }, [_c('b', [_vm._v("ENTERTAINING")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e477319"
    }
  }, [_vm._v("Everyone loves a party, but the trick is to ensure that the cook has a good time, too. Whether you’re planning a casual backyard barbecue, an elegant dinner, or a holiday buffet, a few simple strategies will guarantee you stress-free entertaining.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e479219"
    }
  }, [_c('b', [_vm._v("THINK AHEAD")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e479719"
    }
  }, [_vm._v("• All good parties are well organized. Start with a few lists: a guest list, a menu, a shopping list, and a menu preparation timetable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e480819"
    }
  }, [_vm._v("• Invite guests two to three weeks ahead. Depending on the event you may want to specify the appropriate dress, the type of food that will be served, and the expected duration of the party.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e482319"
    }
  }, [_vm._v("• Simplicity is the key to a successful menu, especially when you’re expecting a large number of guests. The majority of the dishes should be those you’ve cooked and enjoyed in the past. Take advantage of dishes that taste even better when made ahead. It’s also smart to include some dishes that freeze well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e484419"
    }
  }, [_vm._v("• Look for food preparation time-savers. For example, if you’re making a shrimp dish, purchase peeled, deveined shrimp instead of cleaning them yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e485919"
    }
  }, [_vm._v("• Let the menu reflect the time of year. Use seasonal fruits and vegetables whenever possible. They will be at their peak of flavor and reasonably priced.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e487019"
    }
  }, [_vm._v("• Be sure you have a well-stocked bar with plenty of choices for nondrinkers. And keep lots of ice on hand—even more than you think you’ll need.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e488219"
    }
  }, [_vm._v("• At least one week before the party, check your supply of chairs, glasses, serving dishes, and utensils. Consider the space needed to enable guests to circulate easily and, if necessary, shift or remove furniture.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e489919"
    }
  }, [_c('b', [_vm._v("BUFFET BASICS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e490419"
    }
  }, [_vm._v("Buffets are great for carefree entertaining; just put out the food and keep the bowls and platters full. But don’t leave food out at room temperature for longer than two hours, and be sure to replenish the table with fresh platters you’ve prepared in advance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e492219"
    }
  }, [_vm._v("• One of the easiest ways to entertain is to create a menu of room-temperature dishes. Hot buffets, on the other hand, should have one centerpiece dish with simple side dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e493619"
    }
  }, [_vm._v("• Keep desserts simple; cakes and cookies that can be eaten out of hand, for example.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d7e494519"
    }
  }, [_vm._v("• Avoid traffic jams at the buffet table. If possible, place the table in the center of the room, so guests can serve themselves from both sides of the table. Provide two serving utensils for each bowl or tray. Bundle the forks and napkins together and place at both ends of the buffet.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e496819"
    }
  }, [_c('b', [_vm._v("DINNER-PARTY STRATEGIES")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e497319"
    }
  }, [_vm._v("When planning the menu for a dinner party, it is important that the flavors, colors, textures, and richness of the food be well balanced. Follow a creamy soup with a simple roast, and avoid repeating ingredients and flavors. Also, consider the amount of time you’ll need to spend in the kitchen. Soups, stews, casseroles, mousses, sorbets, and baked goods can be made ahead. Try not to have more than two dishes that require your last-minute attention.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0020_001",
      "src": "Images/9781618371621_0020_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e501220"
    }
  }, [_c('i', [_vm._v("Formal table setting: dinner plate, salad plate, bread plate, salad fork, dinner fork, soup spoon, dinner knife, dessert fork, dessert spoon, butter knife, white wine glass, red wine glass, water glass")])]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e502620"
    }
  }, [_c('b', [_vm._v("SETTING A PROPER TABLE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e503120"
    }
  }, [_vm._v("There is a proper way to set a table. To begin, place a dinner plate at each setting. Top with a salad plate. If serving soup, place the soup bowls on top of the salad plates. Set the bread plates to the left of the dinner plates above the forks. Napkins go either to the left of the forks or in the center of the dinner plates.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e505420"
    }
  }, [_vm._v("Flatware is arranged in a common-sense way, in the order used, beginning farther away from the plate. Forks are placed on the left, while knives (cutting edge facing the plate) and spoons are on the right. If you are serving soup, the soup spoons are placed to the right of the knives. If you are serving salad, the salad forks are set to the left of the dinner forks. Butter knives may be placed right on the butter plates.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e508320"
    }
  }, [_vm._v("If you have enough flatware and room on the table, the dessert forks and spoons can be placed above the dinner plates. Otherwise, set out the dessert flatware with the dessert. And don’t forget to provide teaspoons for coffee or tea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e510120"
    }
  }, [_vm._v("• If serving only one wine, place the wineglasses slightly above the dinner knives and set the water glasses to their left. If also serving wine to accompany the first course, place those glasses to the right of the primary wineglasses.")]), _vm._v(" "), _c('p', {
    staticClass: "h1l",
    staticStyle: {
      "color": "#c15b49"
    },
    attrs: {
      "id": "d7e512220"
    }
  }, [_c('b', [_vm._v("WINE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e512720"
    }
  }, [_vm._v("When choosing a beverage to complement a meal, there’s no reason to restrict yourself to wine. Although wine can be suave and elegant or simple and refreshing, when food is spicy or very robust it can overwhelm or compete with a wine unless you choose very carefully. What follows is all you need to know to get you started choosing, serving, and enjoying wine with ease.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e515520"
    }
  }, [_c('b', [_vm._v("KNOW YOUR WINES")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e516020"
    }
  }, [_vm._v("There are two kinds of wine: red (which includes rosé) and white. Wine is described primarily by its relative sweetness. A dry wine lacks natural sugars (but it still can be perceived as fruity), a semidry wine generally tastes sweet, and a sweet wine is very sweet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e517920"
    }
  }, [_vm._v("White wines range from very dry (Manzanilla sherry) to very sweet (Tokay), while red wines are usually dry (except for some kosher-type wines). In general, wines are named either for the predominant grape used in production (cabernet sauvignon) or for the region of production (Chianti). A wine is judged by three basic components: its color, aroma (bouquet), and taste. White wines range in color from pale yellow-green to straw yellow to deep gold, whereas red wines range from purplish red to ruby red.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e521320"
    }
  }, [_vm._v("What is a good wine? Any wine you enjoy drinking. Let your eyes, nose, and mouth be your guides.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e522320"
    }
  }, [_c('i', [_c('b', [_vm._v("White Wines")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e522920"
    }
  }, [_c('b', [_c('i', [_vm._v("Chardonnay ")])]), _vm._v("One of the most popular wines, chardonnay is produced the world over. Most chardon-nays are buttery, fruity, and fairly dry; they are often aged in oak. Chardonnays that have been aged in small oak barrels (sometimes new ones) are often characterized as being “oaky,” a quality that can mask a wine’s lovely fruity qualities. Serve with summer foods, such as grilled salmon or chicken, as well as with roasted chicken or fish.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e526120"
    }
  }, [_c('b', [_c('i', [_vm._v("Gewürztraminer ")])]), _vm._v("A specialty of Alsace, France, although it’s produced in other countries as well. It is a spicy wine that can be dry or semisweet. If dry, serve with fish, poultry, or spicy foods. If sweet, serve with fruit desserts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e528220"
    }
  }, [_c('b', [_c('i', [_vm._v("Riesling ")])]), _vm._v("This wine has a floral fragrance with hints of honey. Late-harvest Riesling is produced from super- ripe grapes that are intensely sweet, making it one of the world’s most delicious wines. German Rieslings are much sweeter than Alsatian Rieslings. They are excellent with Chinese food, lightly spiced food, and roast chicken. Alsatian Rieslings are ideal summertime wines.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e531321"
    }
  }, [_c('b', [_c('i', [_vm._v("Sauvignon Blanc ")])]), _vm._v("A refreshing, clean-flavored wine with a grassy, herbaceous aroma. It is sometimes labeled "), _c('i', [_vm._v("fumé blanc")]), _vm._v(". Serve with poultry, fish, or shellfish.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e533121"
    }
  }, [_c('b', [_c('i', [_vm._v("Red Wines")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d9t02121"
    }
  }, [_c('b', [_c('i', [_vm._v("Beaujolais ")])]), _vm._v("A pleasant, light-bodied, fruity French wine that goes well with meats and poultry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e534421"
    }
  }, [_c('b', [_c('i', [_vm._v("Beaujolais Nouveau ")])]), _vm._v("A light, fruity wine that is seven to nine weeks old and is released for sale on the third Thursday of November. It is an ideal wine to serve at Thanksgiving.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e536121"
    }
  }, [_c('b', [_c('i', [_vm._v("Bordeaux ")])]), _vm._v("Some of the greatest wines in the world are from the Bordeaux region in France. These wines are rich and fragrant and known for their ability to age well. Roast goose, lamb, and other red meats are the perfect partners.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e538221"
    }
  }, [_c('b', [_c('i', [_vm._v("Burgundy ")])]), _vm._v("Wines from the Burgundy region of France are elegant, highly prized, and among the most expensive in the world. Burgundys, made from 100 percent pinot noir grapes, are lighter in body and color than some other red wines. They bear no resemblance to the typical California Burgundy. Enjoy with salmon, red meat, pork, poultry, and game.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e540821"
    }
  }, [_c('b', [_c('i', [_vm._v("Cabernet Sauvignon ")])]), _vm._v("Produced in many countries, this well-known wine is full-bodied and can be complex, with hints of spice and ripe fruit. It complements hearty meats, poultry, and stews.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e542521"
    }
  }, [_c('b', [_c('i', [_vm._v("Chianti ")])]), _vm._v("One of the most famous Italian wines, true Chianti is Tuscan. This sturdy, dry wine goes nicely with tomato-based pasta dishes, steaks, hamburgers, and pizza.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e544221"
    }
  }, [_c('b', [_c('i', [_vm._v("Merlot ")])]), _vm._v("Rich, fragrant, and smooth bodied, this wine is easy to like. Serve with robust foods such as lamb, sausages, stews, braises, and Cornish hens.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e545621"
    }
  }, [_c('b', [_c('i', [_vm._v("Pinot Noir ")])]), _vm._v("This intensely flavored wine is now produced in Oregon and California—often with great success. The wine can be light or full bodied. It goes with almost any food but is especially good with salmon, poultry, pork, veal, ham, and cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e547621"
    }
  }, [_c('b', [_c('i', [_vm._v("Zinfandel ")])]), _vm._v("Originally grown in Europe, “zin” has become a uniquely California wine. It has a spicy, fruity, slight raspberry flavor. It can stand up to hearty foods, such as steaks, lamb, veal chops, game birds, and hamburgers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e550021"
    }
  }, [_c('b', [_c('i', [_vm._v("Other Wines")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e550521"
    }
  }, [_c('b', [_c('i', [_vm._v("Madeira, Sherry, and Port ")])]), _vm._v("These are wines that have been fortified with a spirit (usually brandy) to increase their alcohol content. They are usually enjoyed after a meal, although dry sherry is often sipped before dinner as an apértif.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e552521"
    }
  }, [_c('b', [_c('i', [_vm._v("Rosé ")])]), _vm._v("This light-bodied wine is made from red grapes: The grape skins are left on just long enough to produce the desired pink color. (Inexpensive rosés are often tinted.) Serve well chilled, before dinner or with lighter foods.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e554521"
    }
  }, [_c('b', [_c('i', [_vm._v("Sparkling Wine ")])]), _vm._v("These bubbly wines range from slightly sweet to dry. Champagne is the most famous (even though we often use the term to mean any sparkling wine). True champagne is produced only in the Champagne region of France by the traditional "), _c('i', [_vm._v("méthode champenoise, ")]), _vm._v("but other countries also make fine sparklers, too. Sparkling wines go with every food, including dessert.")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e557921"
    }
  }, [_c('b', [_vm._v("SERVING WINE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e558521"
    }
  }, [_vm._v("Serving wine at the proper temperature helps to bring out all its flavor. Red wine is often served too warm, while white wine is often served too cold, which makes it difficult to fully appreciate them. Red wine should be served at cool room temperature. If it’s too warm, place it in a bucket of ice water for five minutes. Some young and fruity reds, such as Beaujolais, are best when slightly chilled. White wines and sparkling wines should be served well chilled but not so cold that their delicious flavors are hidden. To quick-chill white or sparkling wine, submerge the bottle in a bucket or pot filled with half ice and half water. Or wrap the bottle in several thicknesses of wet paper towels and place in the freezer for 20 to 30 minutes or until chilled. (Check to make sure the wine doesn’t freeze.)")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e563621"
    }
  }, [_vm._v("Wine is traditionally served in stemmed glasses: The large flat base allows you to swirl the wine, which helps release its aroma and flavor. When drinking wine, hold the glass by the stem. This is especially important with chilled wines; it prevents the heat from your hand from warming the wine. Glasses should be filled one-half to two-thirds full to leave enough room for swirling.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e566522"
    }
  }, [_vm._v("Exposing wine to air lets it “breathe” and release its flavor, but simply uncorking the bottle doesn’t do much—the wine needs to be poured. If you wish, decant it (pour it into a decanter) before serving. (If decanting an aged wine, leave any sediment in the bottle.)")]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d7e568422"
    }
  }, [_c('b', [_vm._v("PAIRING WINE WITH FOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e568922"
    }
  }, [_vm._v("There really aren’t any strict rules when it comes to pairing wine with food, but try to match the intensity of the flavors. For example, serve a light wine with a delicate entrée and a robust wine with a full-flavored dish. Gewürztraminer is a good match for gingery Asian dishes, while zinfandel can stand up to the spicy flavors of Mexican food. An easy way to pair wine with food is to serve a wine from the same region or country as the recipe you are preparing. For example, a paella is best enjoyed with a Spanish wine, while pasta with tomato sauce is ideally matched with an Italian red wine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e573022"
    }
  }, [_vm._v("Here are a few rules of thumb: Red wines go well with meats, roast chicken, salmon, tomato-based pasta dishes, and hard cheeses (like Parmesan). White wines are a good match for delicately flavored fish, skillet poultry dishes, vegetable dishes, cheese-based pasta dishes, and soft and semisoft cheeses.")]), _vm._v(" "), _c('p', {
    staticClass: "h1l",
    staticStyle: {
      "color": "#c15b49"
    },
    attrs: {
      "id": "d7e575322"
    }
  }, [_c('b', [_vm._v("COOKING TERMS GLOSSARY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e576222"
    }
  }, [_c('b', [_c('i', [_vm._v("Al dente ")])]), _vm._v("Italian for “to the tooth,” describes perfectly cooked pasta: just tender and with a slight resistance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e577522"
    }
  }, [_c('b', [_c('i', [_vm._v("Baste ")])]), _vm._v("To spoon or brush a liquid over food to keep it moist during cooking. The liquid can be a sauce, marinade, broth, melted butter, or pan juices.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e578922"
    }
  }, [_c('b', [_c('i', [_vm._v("Beat ")])]), _vm._v("To briskly mix or stir a mixture with a spoon, whisk, fork, or electric mixer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e580022"
    }
  }, [_c('b', [_c('i', [_vm._v("Blanch ")])]), _vm._v("To cook food (usually fruits or vegetables) briefly in boiling water, then plunge into ice water to stop the cooking. It locks in the color, texture, and flavor. Blanching is used to loosen tomato and peach skins (for peeling) and to mellow the saltiness or bitterness of certain foods.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e582322"
    }
  }, [_c('b', [_c('i', [_vm._v("Blend ")])]), _vm._v("To mix ingredients until smooth or completely combined.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e583622"
    }
  }, [_c('b', [_c('i', [_vm._v("Blind bake ")])]), _vm._v("To bake a piecrust before it’s filled. To prevent the dough from puffing up during baking, the pastry dough is lined with foil and filled with pie weights or dry beans; they are removed shortly before the end of the baking time to allow the crust to color.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e585622"
    }
  }, [_c('b', [_c('i', [_vm._v("Boil ")])]), _vm._v("To heat a liquid until bubbles break vigorously on the surface (water boils at 212°F). It also means to cook food, such as pasta or potatoes, in a boiling liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e587322"
    }
  }, [_c('b', [_c('i', [_vm._v("Braise ")])]), _vm._v("To cook food by first browning it in fat, then covered, on top of the stove or in the oven, in a small amount of liquid. This slow method tenderizes tough cuts of meat by breaking down their fibers and develops their flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e589322"
    }
  }, [_c('b', [_c('i', [_vm._v("Broth ")])]), _vm._v("A thin, clear liquid produced by simmering in water vegetables, poultry, meat, or fish (on the bone). Broth is used as a base for soups, stews, sauces, and many other dishes. Canned broth is a convenient substitute for homemade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e591322"
    }
  }, [_c('b', [_c('i', [_vm._v("Brown ")])]), _vm._v("To cook over high heat, usually on top of the stove, to brown food.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e592422"
    }
  }, [_c('b', [_c('i', [_vm._v("Butterfly ")])]), _vm._v("To split food, such as shrimp or boneless leg of lamb, horizontally, cutting almost all the way through, then opening it up (like a book) to form a butterfly shape. It exposes a more uniform surface area so food cooks evenly and quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e594422"
    }
  }, [_c('b', [_c('i', [_vm._v("Caramelize ")])]), _vm._v("To heat sugar until it becomes syrupy and golden to deep amber in color. Sugar-topped desserts like crème brûlée are caramelized under the broiler or with a propane torch. Onions become caramelized when slowly cooked until golden brown and very tender.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e596722"
    }
  }, [_c('b', [_c('i', [_vm._v("Core ")])]), _vm._v("To remove the seeds or tough woody centers from fruits such as apples, pears, and pineapple and from vegetables such as cabbage and fennel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e598122"
    }
  }, [_c('b', [_c('i', [_vm._v("Cream ")])]), _vm._v("To beat butter, margarine, or other fat until it’s creamy looking or with sugar until it’s fluffy and light. This technique beats in air, creating light-textured baked goods.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e599822"
    }
  }, [_c('b', [_c('i', [_vm._v("Crimp ")])]), _vm._v("To decoratively pinch or press the edges of a single piecrust or to seal the edges of a double-crusted pie so the filling doesn’t seep out during baking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e601222"
    }
  }, [_c('b', [_c('i', [_vm._v("Curdle ")])]), _vm._v("To coagulate or separate into solids and liquids. Egg- and milk-based mixtures can curdle if heated too quickly, overcooked, or combined with an acid, such as lemon juice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e603423"
    }
  }, [_c('b', [_c('i', [_vm._v("Cut in ")])]), _vm._v("To work a solid fat, such as shortening, butter, or margarine, into dry ingredients using a pastry blender or two knives scissor-fashion until the pieces are the desired size.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e605123"
    }
  }, [_c('b', [_c('i', [_vm._v("Deglaze ")])]), _vm._v("To scrape up the flavorful browned bits from the bottom of a skillet or roasting pan in which meat or poultry has been cooked by adding water, wine, or broth and stirring while gently heating.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e606823"
    }
  }, [_c('b', [_c('i', [_vm._v("Devein ")])]), _vm._v("To remove the dark intestinal vein of shrimp. The shrimp is first peeled, then a lengthwise slit is made along the back, exposing the vein so that it can be removed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e608523"
    }
  }, [_c('b', [_c('i', [_vm._v("Dollop ")])]), _vm._v("A spoonful of soft food, such as pesto, yogurt, whipped cream, or créme fraîche.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e609523"
    }
  }, [_c('b', [_c('i', [_vm._v("Dot ")])]), _vm._v("To scatter bits of butter or margarine over a pie filling, casserole, or other dish before baking. It adds richness and flavor and helps promote browning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e610923"
    }
  }, [_c('b', [_c('i', [_vm._v("Dredge ")])]), _vm._v("To lightly coat with flour, cornmeal, or bread crumbs. Meats and fish are dredged before cooking to create a crisp, browned exterior.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e612323"
    }
  }, [_c('b', [_c('i', [_vm._v("Drippings ")])]), _vm._v("The melted fat and juices that collect in a pan when meat or poultry is cooked. Drippings form the base for gravies and pan sauces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e613723"
    }
  }, [_c('b', [_c('i', [_vm._v("Drizzle ")])]), _vm._v("To pour melted butter, oil, syrup, melted chocolate, or other liquid back and forth over food in a fine stream.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e615023"
    }
  }, [_c('b', [_c('i', [_vm._v("Dust ")])]), _vm._v("To coat lightly with flour (greased baking pans) or with confectioners’ sugar or cocoa (cakes and pastries) or another powdery ingredient.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e616423"
    }
  }, [_c('b', [_c('i', [_vm._v("Emulsify ")])]), _vm._v("To bind liquids that usually can’t blend easily, such as oil and vinegar. The trick is to slowly add one liquid, usually the oil, to the other while mixing vigorously. Natural emulsifiers, such as egg yolks or mustard, are often added to vinaigrettes or sauces to emulsify them for a longer period.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e618823"
    }
  }, [_c('b', [_c('i', [_vm._v("Ferment ")])]), _vm._v("To bring about a chemical change in foods and beverages that is caused by enzymes in bacteria or yeasts. Beer, wine, yogurt, buttermilk, vinegar, cheese, and yeast breads all get their distinctive flavors from fermentation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e620823"
    }
  }, [_c('b', [_c('i', [_vm._v("Flour ")])]), _vm._v("As a verb, means to coat food, a surface, or a baking pan with flour.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e621823"
    }
  }, [_c('b', [_c('i', [_vm._v("Fold ")])]), _vm._v("To combine a light mixture (such as beaten egg whites, whipped cream, or sifted flour) with a heavier mixture (such as a cake batter or the base of a soufflé) without deflating either. A rubber spatula is the best tool to use for folding.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e624023"
    }
  }, [_c('b', [_c('i', [_vm._v("Fork-tender ")])]), _vm._v("A degree of doneness for cooked vegetables and meats. When the food is pierced with a fork, there is only a very slight resistance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e625323"
    }
  }, [_c('b', [_c('i', [_vm._v("Glaze ")])]), _vm._v("To coat food by brushing with melted jelly, jam, or barbecue sauce or to brush piecrust with milk or beaten egg before baking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e626723"
    }
  }, [_c('b', [_c('i', [_vm._v("Grill ")])]), _vm._v("To cook food directly or indirectly over a source of heat (usually charcoal, briquettes, or gas) or in a special ridged pan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e628123"
    }
  }, [_c('b', [_c('i', [_vm._v("Julienne ")])]), _vm._v("To cut food, especially vegetables, into thin, uniform matchstick strips about 2 inches long.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e629223"
    }
  }, [_c('b', [_c('i', [_vm._v("Knead ")])]), _vm._v("To work dough until it’s smooth and elastic, either by pressing and folding with the heel of the hand or by working it in a heavy-duty electric mixer with a dough hook. Kneading develops the gluten in flour, an elastic protein that gives yeast breads their structure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e631223"
    }
  }, [_c('b', [_c('i', [_vm._v("Leavening ")])]), _vm._v("An agent that causes dough or batter to rise. Common leaveners include baking powder, baking soda, and yeast. Natural leaveners are air (when beaten into eggs) and steam (in popovers, éclairs, and cream puffs).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e633223"
    }
  }, [_c('b', [_c('i', [_vm._v("Marinate ")])]), _vm._v("To flavor and/or tenderize a food by letting it sit in a liquid (such as lemon juice, wine, or yogurt) and, often, oil, herbs, or spices. When a marinade contains an acid, the marinating should be done in a nonreactive container.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e635223"
    }
  }, [_c('b', [_c('i', [_vm._v("Panfry ")])]), _vm._v("To cook food in a small amount of fat in a skillet until browned and cooked through.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e636323"
    }
  }, [_c('b', [_c('i', [_vm._v("Parboil ")])]), _vm._v("To partially cook food in boiling water. Carrots are often parboiled before they’re added to other foods that take less time to cook.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e637923"
    }
  }, [_c('b', [_c('i', [_vm._v("Pare ")])]), _vm._v("To cut away the skin or rind of a fruit or vegetable. A vegetable peeler or paring knife (a small knife with a 3- to 4-inch blade) is usually used.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e639323"
    }
  }, [_c('b', [_c('i', [_vm._v("Pasteurize ")])]), _vm._v("To kill the bacteria in milk, fruit juices, or other liquids by heating to a moderately high temperature, then rapidly cooling it. All milk sold in the U.S. is pasteurized. Ultrapasteurized (UHT) milk is subjected to very high temperatures—about 300°F—and vacuum-packed for extended storage. It will keep without refrigeration for up to six months but must be refrigerated once it’s opened. Ultrapasteurized cream is not vacuum-packed; it must be refrigerated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e642523"
    }
  }, [_c('b', [_c('i', [_vm._v("Pinch ")])]), _vm._v("The amount of a powdery ingredient, such as salt, pepper, or a spice, you can hold between your thumb and forefinger; about 1.16 teaspoon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e645324"
    }
  }, [_c('b', [_c('i', [_vm._v("Pipe ")])]), _vm._v("To force a food, such as frosting, whipped cream, or mashed potatoes, through a pastry bag fitted with a pastry tip in a decorative manner or to shape meringues or éclairs. You can also use a plastic bag with a corner snipped off.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e647324"
    }
  }, [_c('b', [_c('i', [_vm._v("Poach ")])]), _vm._v("To cook food in a gently simmering (barely moving) liquid: The amount and type of liquid will depend on the food being poached.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e648724"
    }
  }, [_c('b', [_c('i', [_vm._v("Pound ")])]), _vm._v("To flatten to a uniform thickness using a meat mallet, meat pounder, or rolling pin. Meat and poultry is pounded to ensure even cooking. Pounding also tenderizes tough meats by breaking up hard-to-chew connective tissue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e650724"
    }
  }, [_c('b', [_c('i', [_vm._v("Preheat ")])]), _vm._v("To bring an oven or broiler to the desired temperature before cooking food.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e651724"
    }
  }, [_c('b', [_c('i', [_vm._v("Prick ")])]), _vm._v("To pierce a food, such as a piecrust or a potato, usually with a fork, to prevent it from puffing up or bursting during cooking/baking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e653124"
    }
  }, [_c('b', [_c('i', [_vm._v("Proof ")])]), _vm._v("To dissolve yeast in a measured amount of warm water (105° to 115°F), sometimes with a small amount of sugar and then set it aside until foamy to make sure that it is “active.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e654824"
    }
  }, [_c('b', [_c('i', [_vm._v("Punch down ")])]), _vm._v("To deflate yeast dough after it has risen fully. It is not necessary to literally “punch” down the dough; it needs only to be gently deflated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e656224"
    }
  }, [_c('b', [_c('i', [_vm._v("Puree ")])]), _vm._v("To mash or grind food until completely smooth, usually in a food processor, blender, sieve, or food mill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e657624"
    }
  }, [_c('b', [_c('i', [_vm._v("Reduce ")])]), _vm._v("To rapidly boil a liquid, such as a sauce, wine, or stock, until it has reduced in volume in order to concentrate the flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e659024"
    }
  }, [_c('b', [_c('i', [_vm._v("Render ")])]), _vm._v("To slowly cook animal fat or skin until the fat separates from its connective tissue. It is strained before being used. The crisp brown bits left in the pan are called cracklings.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e660724"
    }
  }, [_c('b', [_c('i', [_vm._v("Roast ")])]), _vm._v("To cook in an uncovered pan in the oven by dry heat. Roasted food develops a well-browned exterior. Tender cuts of meat, poultry, and fish are suitable for roasting, as are many vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e662424"
    }
  }, [_c('b', [_c('i', [_vm._v("Rolling boil ")])]), _vm._v("A full constant boil that cannot be stirred down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e663424"
    }
  }, [_c('b', [_c('i', [_vm._v("Sauté ")])]), _vm._v("To cook food quickly in a small amount of hot fat in a skillet; the term derives from the French word "), _c('i', [_vm._v("sauter ")]), _vm._v(" (“to jump”).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e665224"
    }
  }, [_c('b', [_c('i', [_vm._v("Scald ")])]), _vm._v("To heat a liquid, such as cream or milk, just until tiny bubbles appear around the edge of the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e666524"
    }
  }, [_c('b', [_c('i', [_vm._v("Score ")])]), _vm._v("To make shallow cuts (usually parallel or crisscross) in the surface of food before cooking. This is done mainly to facilitate flavor absorption, as in marinated meats, chicken, and fish, but sometimes also for decorative purposes on hams. The tops of breads are often scored to enable them to rise (during baking) without bursting.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e669124"
    }
  }, [_c('b', [_c('i', [_vm._v("Sear ")])]), _vm._v("To brown meat, fish, or poultry quickly by placing over very high heat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e670224"
    }
  }, [_c('b', [_c('i', [_vm._v("Shave ")])]), _vm._v("To cut wide, paper-thin slices of food, such as Parmesan cheese or chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e671224"
    }
  }, [_c('b', [_c('i', [_vm._v("Shred ")])]), _vm._v("To cut, tear, or grate food into narrow strips or pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e672324"
    }
  }, [_c('b', [_c('i', [_vm._v("Shuck ")])]), _vm._v("To remove the shells of oysters, mussels, scallops, or clams.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e673424"
    }
  }, [_c('b', [_c('i', [_vm._v("Sift ")])]), _vm._v("To press ingredients, such as flour or confectioners’ sugar, through a sifter or sieve. Sifting incorporates air and removes lumps, which helps ingredients to combine more easily.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e675124"
    }
  }, [_c('b', [_c('i', [_vm._v("Simmer ")])]), _vm._v("To cook food in a liquid over low heat (at about 185°F). A few small bubbles should be visible on the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e676424"
    }
  }, [_c('b', [_c('i', [_vm._v("Skim ")])]), _vm._v("To remove fat or froth from the surface of a liquid, such as broth, boiling jelly, or soup. A skimmer, a long-handled metal utensil with a flat mesh disk or perforated bowl at one end, is the ideal tool for the job.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e678124"
    }
  }, [_c('b', [_c('i', [_vm._v("Soft peaks ")])]), _vm._v("When cream or egg whites are beaten until they stand in peaks that bend over at the top when the beaters are lifted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e679524"
    }
  }, [_c('b', [_c('i', [_vm._v("Steam ")])]), _vm._v("To cook food, covered, over a small amount of boiling water. The food is usually set on a rack or in a basket. Since it’s not immersed in water, the food retains more of its nutrients, color, and flavor than it would with other cooking methods.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e681524"
    }
  }, [_c('b', [_c('i', [_vm._v("Stiff peaks ")])]), _vm._v("When cream or egg whites are beaten until they stand in firm peaks that hold their shape when the beaters are lifted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e682924"
    }
  }, [_c('b', [_c('i', [_vm._v("Stir-fry ")])]), _vm._v("To cook pieces of food quickly in a small amount of oil over high heat, stirring and tossing almost constantly. Stir-frying is used in Asian cooking; a wok is the traditional pan, although a large skillet will do just as well.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e684924"
    }
  }, [_c('b', [_c('i', [_vm._v("Temper ")])]), _vm._v("To warm food gently before adding it to a hot mixture so it doesn’t separate or curdle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e686024"
    }
  }, [_c('b', [_c('i', [_vm._v("Tender-crisp ")])]), _vm._v("The ideal degree of doneness for many fresh vegetables: They’re tender but still retain some of their crunch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e687925"
    }
  }, [_c('b', [_c('i', [_vm._v("Toast ")])]), _vm._v("To brown bread, croutons, whole spices, or nuts in a dry skillet or in the oven. Toasting enhances the flavor of nuts and facilitates removal of the skin from hazelnuts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e689625"
    }
  }, [_c('b', [_c('i', [_vm._v("Toss ")])]), _vm._v("To lift and drop pieces of food quickly and gently with two utensils, usually to coat them with a sauce (as for pasta) or a dressing (as for salad).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e690925"
    }
  }, [_c('b', [_c('i', [_vm._v("Whip ")])]), _vm._v("To beat an ingredient (especially heavy or whipping cream) or mixture rapidly to incorporate air and increase volume. You can use a whisk, egg beater, or electric mixer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e692625"
    }
  }, [_c('b', [_c('i', [_vm._v("Whisk ")])]), _vm._v("To beat ingredients (such as heavy or whipping cream, eggs, salad dressings, or sauces) with a fork or whisk to mix, blend, or incorporate air.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e694025"
    }
  }, [_c('b', [_c('i', [_vm._v("Zest ")])]), _vm._v("To remove the flavorful colored part of citrus skin. Use the fine holes of a grater, a zester, or a vegetable peeler, avoiding the bitter white pith underneath.")]), _vm._v(" "), _c('p', {
    staticClass: "h1l",
    staticStyle: {
      "color": "#c15b49"
    },
    attrs: {
      "id": "d7e695625"
    }
  }, [_c('b', [_vm._v("INGREDIENTS GLOSSARY")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e696125"
    }
  }, [_c('b', [_c('i', [_vm._v("Almond paste ")])]), _vm._v("A firm but pliable confection made of ground almonds and confectioners’ sugar mixed with glucose, corn syrup, or egg white. Available in cans or tubes, almond paste is similar to "), _c('i', [_vm._v("marzipan")]), _vm._v(", which is sweeter and softer. If almond paste seems hard, microwave on High for a few seconds to soften.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e698825"
    }
  }, [_c('b', [_c('i', [_vm._v("Amaretti cookies ")])]), _vm._v("Crisp, round almond-flavored Italian cookies, found at Italian grocers and specialty food stores. They often come tissue-wrapped in pairs and packed into pretty tin boxes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e700525"
    }
  }, [_c('b', [_c('i', [_vm._v("Calvados ")])]), _vm._v("An apple brandy made in the Normandy region of France. Applejack is a good substitute.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e701625"
    }
  }, [_c('b', [_c('i', [_vm._v("Capers ")])]), _vm._v("The flower buds of a bush native to parts of the Mediterranean and Asia. They are usually dried and then pickled in a vinegar brine. Also available at specialty food stores are capers packed in salt, which have a purer flavor. Capers should be rinsed under cold water and drained before using.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e703925"
    }
  }, [_c('b', [_c('i', [_vm._v("Chili powder ")])]), _vm._v("A blend of ground dried mild chiles and ingredients such as cumin and garlic powder. Ground dried chiles without added seasonings are also available and sometimes labeled chile powder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e705825"
    }
  }, [_c('b', [_c('i', [_vm._v("Chipotles en adobo ")])]), _vm._v("Dried, smoked red jalapeño peppers canned in a thick chile puree called "), _c('i', [_vm._v("adobo.")]), _vm._v(" Handle these chiles and their sauce with care; they are very hot and can easily burn your skin. Leftover "), _c('i', [_vm._v("chipotles en adobo ")]), _vm._v("can be frozen. Freeze individual chiles with some sauce on a waxed paper–lined cookie sheet until firm, then remove from the waxed paper and store in a heavy-duty zip-tight plastic bag for up to three months. "), _c('i', [_vm._v("Chipotles en adobo ")]), _vm._v("can be found in Latino markets and many supermarkets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e710825"
    }
  }, [_c('b', [_c('i', [_vm._v("Chorizo ")])]), _vm._v("A spicy pork sausage seasoned with chiles and garlic. Spanish-style chorizo is a firm, smoked link sausage. Do not substitute Mexican-style fresh chorizo.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e712525"
    }
  }, [_c('b', [_c('i', [_vm._v("Cilantro ")])]), _vm._v("A pungent green herb, popular in Asian and Latino cooking; sometimes called fresh coriander or Chinese parsley. It is often sold with the roots still attached; the roots are sometimes chopped and used as a seasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e714625"
    }
  }, [_c('b', [_c('i', [_vm._v("Cinnamon sticks ")])]), _vm._v("Used to garnish hot beverages. They can also be simmered in a liquid to release their warm, spicy flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e716225"
    }
  }, [_c('b', [_c('i', [_vm._v("Coconut milk ")])]), _vm._v("An unsweetened infusion of shredded coconut meat and water that is strained and canned. It is not interchangeable with cream of coconut, which is rich, sweet, and used in desserts and tropical mixed drinks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e718225"
    }
  }, [_c('b', [_c('i', [_vm._v("Cornichons ")])]), _vm._v("Tiny gherkinlike cucumbers that are pickled in a tart brine. Small dill pickles are an acceptable substitute if the cornichons are to be chopped and used in a sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e719925"
    }
  }, [_c('b', [_c('i', [_vm._v("Crab boil ")])]), _vm._v("A mix of herbs and spices (such as mustard seeds, whole allspice, peppercorns, bay leaves, and dried chiles) that is sometimes added to the water in which crab, shrimp, or lobster is cooked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e721625"
    }
  }, [_c('b', [_c('i', [_vm._v("Curry powder ")])]), _vm._v("Widely used in Indian cooking, the blend of spices and heat intensity can greatly vary. A typical curry powder can contain up to twenty different spices, including turmeric, cardamom, red chiles, black pepper, and cumin. Madras-style curry powder, available in supermarkets, is a reliable moderately spicy blend.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e724425"
    }
  }, [_c('b', [_c('i', [_vm._v("Durum ")])]), _vm._v("A hard wheat that is ground to make semolina flour, which is used for pasta.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e725525"
    }
  }, [_c('b', [_c('i', [_vm._v("Espresso coffee powder, instant ")])]), _vm._v("Available at Italian grocers and many supermarkets, it is a convenient way to add rich, deep-roasted coffee flavor to food and beverages.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e727726"
    }
  }, [_c('b', [_c('i', [_vm._v("Fish sauce ")])]), _vm._v("An integral flavoring in Southeast Asian cooking, it is made from fermented fish. Also known as "), _c('i', [_vm._v("nam pla ")]), _vm._v(" (Thai) and "), _c('i', [_vm._v("nuoc nam ")]), _vm._v(" (Vietnam); the Philippine version, "), _c('i', [_vm._v("pastis, ")]), _vm._v("has a much milder flavor. Store at cool room temperature in a dark place; it will keep for about one year.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e731026"
    }
  }, [_c('b', [_c('i', [_vm._v("Five-spice powder ")])]), _vm._v("A favorite seasoning in Chinese cooking; it is usually a blend of equal parts cinnamon, cloves, fennel, star anise, and Szechwan peppercorns.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e732426"
    }
  }, [_c('b', [_c('i', [_vm._v("Hoisin sauce ")])]), _vm._v("This sweet, thick sauce is made from a base of soybeans. Refrigerate after opening. Often used in Chinese barbecue sauces for chicken and ribs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e733826"
    }
  }, [_c('b', [_c('i', [_vm._v("Juniper berries ")])]), _vm._v("Fragrant dried blue-black berries that are used as a seasoning and the main flavoring in gin. They can usually be found in spice shops and specialty food stores. If unavailable, stir 1 to 2 tablespoons of gin into the finished dish during the last five minutes of cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e736126"
    }
  }, [_c('b', [_c('i', [_vm._v("Kirsch ")])]), _vm._v("Also called "), _c('i', [_vm._v("kirschwasser ")]), _vm._v(" (German for “cherry water”), a clear brandy distilled from cherry juice and pits. (This type of clear spirit made from fruit is called "), _c('i', [_vm._v("eau-de-vie.")]), _vm._v(") Often used to flavor fondues and desserts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e739026"
    }
  }, [_c('b', [_c('i', [_vm._v("Mango chutney ")])]), _vm._v("A sweet and spicy condiment that is often served with curries. Major Grey’s is made in the British style, slightly sweeter than Indian chutneys.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e740426"
    }
  }, [_c('b', [_c('i', [_vm._v("Maple syrup, pure ")])]), _vm._v("Maple sap that has been boiled down until syrupy. It has a delicious subtle flavor that is incomparable. Maple-flavored syrup is made from a liquid such as corn syrup mixed with a small amount of pure maple syrup. Pancake syrup is corn syrup with natural or artificial maple extract added.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e742726"
    }
  }, [_c('b', [_c('i', [_vm._v("Marsala ")])]), _vm._v("A fortified wine, originally from Sicily but also produced in California; available sweet (best for desserts) and dry (use in savory dishes).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e744126"
    }
  }, [_c('b', [_c('i', [_vm._v("Miso ")])]), _vm._v("A highly concentrated fermented soybean paste made from a combination of soybeans and grain that is widely used in Japanese cooking and made in different strengths. "), _c('i', [_vm._v("Red miso ")]), _vm._v("has the strongest flavor; "), _c('i', [_vm._v("golden ")]), _vm._v("is fairly mild; and "), _c('i', [_vm._v("white miso ")]), _vm._v("is mellow and slightly sweet. Look for miso in natural food stores and Asian markets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e747826"
    }
  }, [_c('b', [_c('i', [_vm._v("Molasses ")])]), _vm._v("A by-product of sugar refining, molasses is the liquid that remains after the sugar crystals are extracted. Molasses can be sulphured or unsulphured. Light molasses is from the first boiling (refining) and has a mild flavor. Dark molasses is from the second boiling and is darker and less sweet. Blackstrap molasses, from the third boiling, is bitter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e750826"
    }
  }, [_c('b', [_c('i', [_vm._v("Mustard, Dijon ")])]), _vm._v("This prepared mustard gets its distinctive flavor from a special blend of mustard seeds and white wine. There are many different brands, with varying heat levels, so when you find a brand you like, stick with it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e752826"
    }
  }, [_c('b', [_c('i', [_vm._v("Old Bay seasoning ")])]), _vm._v("An aromatic, somewhat hot blend of ground spices that is popular with cooks in the Chesapeake Bay area, especially for seafood dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e754226"
    }
  }, [_c('b', [_c('i', [_vm._v("Olives ")])]), _vm._v("The fruit of the olive tree is naturally very bitter and must be processed to make it edible. There are many olive varieties, and the finished product depends on the ripeness of the fruit and the type of processing. While each has a particular flavor, many are interchangeable. Black olives include the tiny Niçoise, the gray-black Gaeta, the vinegar-cured Kalamata (also available pitted), and the pleasantly bitter, wrinkled, oil-cured Moroccan. Picholine and manzanilla are two popular green olives. To remove the pits from olives, use an olive or cherry pitter. Or put the olives on a work surface, place the flat side of a large knife on top of one olive, and press down to lightly crush the olive; remove the pit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e759026"
    }
  }, [_c('b', [_c('i', [_vm._v("Olive oil ")])]), _vm._v("Pressing tree-ripened olives produces the prized liquid we know as olive oil. Its flavor, color, and fragrance depend on the region of origin and the quality of the harvest. In general, extra-virgin olive oil, from the first pressing, is full-flavored, bright green to green-gold in color, and best used on salads or other dishes where its taste can be most appreciated. Regular olive oil (sometimes called pure olive oil) is from a subsequent pressing and has a milder but still distinctive fruity flavor; it’s a good cooking oil. “Light” olive oil has been specially treated to remove much of the characteristic olive taste; it is not lower in fat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e763326"
    }
  }, [_c('b', [_c('i', [_vm._v("Pancetta ")])]), _vm._v("An unsmoked bacon that is rolled into a cylinder and sliced to order. It is used in Italian dishes. Pancetta is available at Italian delicatessens, specialty food stores, and some supermarkets. Substitute regular smoked bacon, if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e765526"
    }
  }, [_c('b', [_c('i', [_vm._v("Pepper ")])]), _vm._v("The world’s most popular spice, peppercorns are the dried berries of a perennial vine. They come in three colors: black, white, and green. Black pepper is picked just before the berry ripens; the skin turns black when dried. White pepper is the ripened berry with the skin removed; it has a milder flavor than black pepper. Green peppercorns are soft, underripe berries, usually preserved in brine. Freshly ground pepper has an incomparable flavor, so it’s worth the investment to purchase a good-quality pepper mill (grinder). Some recipes call for coarse-cracked pepper (also called butcher’s grind), but it’s just as easy to crush your own peppercorns in a mortar with a pestle or on a work surface with a heavy skillet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e771027"
    }
  }, [_c('b', [_c('i', [_vm._v("Pine nuts ")])]), _vm._v("From the pinecones of certain pine trees, these small, elongated ivory-colored nuts are sometimes called "), _c('i', [_vm._v("pignoli ")]), _vm._v("or "), _c('i', [_vm._v("piñon. ")]), _vm._v("They turn rancid easily; store in the refrigerator for up to three months or freeze for up to nine months.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e773927"
    }
  }, [_c('b', [_c('i', [_vm._v("Porcini mushrooms, dried ")])]), _vm._v("These members of "), _c('i', [_vm._v("Bo-letus edulis ")]), _vm._v("are imported from Italy and have a rich, earthy flavor; the French variety, called "), _c('i', [_vm._v("cèpes")]), _vm._v(", are more expensive. They must be rehydrated in hot water before use. After soaking, rinse them under cold running water to remove any grit. Use the flavorful soaking liquid to add extra mushroom flavor. Available in specialty food stores and Italian markets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e777727"
    }
  }, [_c('b', [_c('i', [_vm._v("Prosciutto ")])]), _vm._v("A cured, aged, air-dried ham with a firm texture and delicious salty flavor. Imported Italian prosciutto, available at quality grocers and butchers, has a milder flavor than the domestic variety.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e779427"
    }
  }, [_c('b', [_c('i', [_vm._v("Salt ")])]), _vm._v("There are so many kinds of salt available, it’s easy to take this familiar ingredient for granted. Each has a different level of saltiness, so it’s helpful to understand the differences. We tested our recipes with fine-grained table salt, which has additives that keep it free flowing. Iodized salt is table salt that has been treated with iodine (which helps prevent hyperthyroidism). Kosher salt has no additives. Some cooks prefer it for its mild flavor and its coarse texture, which makes it easy to pick up for sprinkling. Sea salt is also less salty than common table salt. If you use kosher or sea salt in your cooking, you will need a larger quantity. Grayish rock salt is not a food-quality salt but is used in old-fashioned ice-cream makers and as a bed upon which to bake and serve stuffed oysters and clams.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e784827"
    }
  }, [_c('b', [_c('i', [_vm._v("Savoiardi ")])]), _vm._v("Long, crisp, Italian-style ladyfingers that are usually layered with a moist filling to soften them, as in tiramisù.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e786227"
    }
  }, [_c('b', [_c('i', [_vm._v("Semolina ")])]), _vm._v("A coarse, sandlike grind of durum wheat used to make pasta and some breads.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e787427"
    }
  }, [_c('b', [_c('i', [_vm._v("Sesame oil, Asian ")])]), _vm._v("Dark brown-orange in color, this oil is pressed from roasted sesame seeds. It is generally used as a seasoning, not a cooking oil.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e788727"
    }
  }, [_c('b', [_c('i', [_vm._v("Soy sauce ")])]), _vm._v("Made from fermented soybeans and roasted wheat or barley, this dark, salty sauce is indispensable in Asian cooking. There are many different versions, and some can be quite salty. Use a reliable Japanese brand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e790827"
    }
  }, [_c('b', [_c('i', [_vm._v("Star anise ")])]), _vm._v("A star-shaped spice with eight points, each containing a seed. Often used in Chinese cooking, it has a delicate licorice flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e792127"
    }
  }, [_c('b', [_c('i', [_vm._v("Tahini ")])]), _vm._v("Sesame seeds ground into a thick paste; stir well to incorporate the oil that rises to the top. Available at natural food stores and most supermarkets.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e793727"
    }
  }, [_c('b', [_c('i', [_vm._v("Tapenade ")])]), _vm._v("A French olive paste seasoned with anchovies, herbs, and garlic and used as a condiment. The Italian version is called "), _c('i', [_vm._v("olivada.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e795527"
    }
  }, [_c('b', [_c('i', [_vm._v("Tomatoes, dried ")])]), _vm._v("Often referred to as “sun-dried” tomatoes but rarely dried in the sun anymore, these intensely flavored dehydrated tomatoes are processed by more commercial methods. They can be purchased loose packed or packed with oil in a jar. Loose-packed dried tomatoes should be soaked in boiling water to cover until softened, then drained.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e798427"
    }
  }, [_c('b', [_c('i', [_vm._v("Vinegar ")])]), _vm._v("Bacterial activity can turn some liquids into vinegar; "), _c('i', [_vm._v("vin aigre ")]), _vm._v("means “sour wine.” "), _c('i', [_vm._v("Cider vinegar, ")]), _vm._v("made from apple juice, is a popular vinegar. "), _c('i', [_vm._v("Distilled white vinegar ")]), _vm._v("has a strong flavor but is preferred for pickling because it doesn’t darken food. Red and white wines are also made into vinegars. The more expensive vinegars are produced by an ancient process that slowly turns the wine sour, instead of by inoculating them with fast-acting bacteria. "), _c('i', [_vm._v("Tarragon vinegar ")]), _vm._v("is white wine that has been infused with tarragon. "), _c('i', [_vm._v("Balsamic vinegar ")]), _vm._v("is made from semidry Trebbiano grapes, so the resulting vinegar has a sweet note. Most supermarket varieties are tasty, but they aren’t true balsamic vinegars, which are aged for years in wood caskets and are quite expensive. "), _c('i', [_vm._v("Malt vinegar, ")]), _vm._v("a British favorite, is a mild vinegar made from malted barley.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e9915228"
    }
  }, [_c('b', [_c('i', [_vm._v("Wonton wrappers ")])]), _vm._v("Delicate thin squares of wheat noodles, they can be stuffed to make wontons or other dumplings or ravioli. Look for them in the refrigerated section of the supermarket or at Asian grocery stores. Wrap leftover wrappers in plastic wrap and heavy-duty foil and freeze for up to one month.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655db8f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c7_r1.vue
// module id = 87
// module chunks = 0